window.codepoet = {
    home_slider: false,
    home_slider_auto_started: false,
    video_carousel: false,
    post_carousel: false,
    news_carousel: false,
    sliders: [],
    ecom_slider: false,
    guides: "",
    single_guides: [],
    guides_autocomplete: [],
    guide_selected: {},
    guides_select: {
        cats: {},
        products: {},
        years: {},
    },
    guides_html: false,
    current_geocode: "",
    current_experience_country: "",
    geocoder: "",
    geo_code_request: false,
    current_host: location.protocol + "//" + window.location.hostname,
    current_url: window.location.href,
    fadeInUp: "",
    current_url_static: false,
    videoElevate: false,
    videoElevateDuration: 0,
    initialized_select_store_btn: false,
    checkout_store_search_btn: false,
    v2slider: false,
    v3slider: false,
    prodmenuv3: false,
    northmenu: false,
    is_wpsl_pop: false,
};

var isMobile = false; //initiate as false
// device detection
if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        navigator.userAgent.substr(0, 4)
    )
) {
    isMobile = true;
}

jQuery.fn.tawcvs_variation_swatches_form = function () {
    return this.each(function () {
        var $form = jQuery(this),
            clicked = null,
            selected = [];

        $form

            .addClass("swatches-support")

            .on("click", ".swatch", function (e) {
                e.preventDefault();

                var $el = jQuery(this),
                    $select = $el.closest(".value").find("select"),
                    attribute_name =
                        $select.data("attribute_name") || $select.attr("name"),
                    value = $el.data("value");

                $el.closest("tr")
                    .find("span.item_value")
                    .text($select.find('option[value="' + value + '"]').text());

                if ($el.hasClass("selected")) {
                    return false;
                }

                $select.trigger("focusin");

                // Check if this combination is available

                if (!$select.find('option[value="' + value + '"]').length) {
                    $el.parent()
                        .siblings(".swatch-item-wrapper")
                        .find(".swatch")
                        .removeClass("selected");

                    $select.val("").change();

                    $form.trigger("tawcvs_no_matching_variations", [$el]);

                    return;
                }

                clicked = attribute_name;

                if (selected.indexOf(attribute_name) === -1) {
                    selected.push(attribute_name);
                }

                if ($el.hasClass("selected")) {
                    $select.val("");

                    $el.removeClass("selected");

                    delete selected[selected.indexOf(attribute_name)];
                } else {
                    $el.addClass("selected")
                        .parent()
                        .siblings(".swatch-item-wrapper")
                        .find(".selected")
                        .removeClass("selected");

                    $select.val(value);
                }

                jQuery("#add_to_cart_bar").removeClass("active");

                $select.change();
            })

            .on("click", ".reset_variations", function () {
                jQuery(this)
                    .closest(".variations_form")
                    .find(".swatch.selected")
                    .removeClass("selected");
                jQuery("span.item_value").text("");

                selected = [];
            })

            .on("tawcvs_no_matching_variations", function () {
                window.alert(
                    wc_add_to_cart_variation_params.i18n_no_matching_variations_text
                );
            });
    });
};

setTimeout(function () {
    if (document.readyState != "complete") {
        document.getElementById("loader_loading_text").style.display =
            "inline-block";
    }
}, 3500);

jQuery(document).ready(function ($) {
    site_loading(false);
});

(function ($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var codepoet = {
        // All pages
        common: {
            init: function () {
                jQuery("#productsmenu .labels .columns").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                        if (jQuery(this).hasClass("active")) {
                            return false;
                        }
                        if (jQuery(this).find("a").length) {
                            window.location.href = jQuery(this)
                                .find("a")
                                .attr("href");
                            return false;
                        }
                        let id = "#" + jQuery(this).data("link") + "-block";
                        jQuery("#productsmenu .labels .columns").removeClass(
                            "active"
                        );
                        jQuery(this).addClass("active");
                        jQuery("#productsmenu .menu_product_wrapper").fadeOut(
                            150
                        );
                        setTimeout(function () {
                            jQuery(id).fadeIn(150);
                        }, 150);
                    }
                );
                jQuery(".new_menu_v2 a").on("click", function (event) {
                    event.preventDefault();
                    jQuery.fancybox.open({
                        src: "#productsmenu",
                        type: "inline",
                        opts: {
                            touch: false,
                            autoFocus: false,
                            backFocus: false,
                            trapFocus: false,
                        },
                    });
                });
                jQuery(".new_menu_v3 a").on("click", function (event) {
                    event.preventDefault();

                    if (jQuery(this).parent().hasClass("active")) {
                        if (window.prodmenuv3) {
                            window.prodmenuv3.close();
                            jQuery(this).parent().removeClass("active");
                        }
                        return false;
                    }
                    if (window.northmenu) {
                        window.northmenu.close();
                        jQuery(".new_menu_north a")
                            .parent()
                            .removeClass("active");
                    }

                    jQuery(this).parent().addClass("active");
                    window.prodmenuv3 = jQuery.fancybox.open(
                        {
                            src: "#productsmenu",
                            type: "inline",
                            opts: {
                                touch: false,
                                autoFocus: false,
                                backFocus: false,
                                trapFocus: false,
                            },
                        },
                        {
                            baseClass: "customProductsFancy",
                            afterClose: function (instance, current, e) {
                                jQuery(".new_menu_v3 a")
                                    .parent()
                                    .removeClass("active");
                            },
                        }
                    );
                });
                jQuery(".new_menu_north a").on("click", function (event) {
                    event.preventDefault();
                    if (jQuery(this).parent().hasClass("active")) {
                        if (window.northmenu) {
                            window.northmenu.close();
                            jQuery(this).parent().removeClass("active");
                        }
                        return false;
                    }
                    jQuery(this).parent().addClass("active");
                    if (window.prodmenuv3) {
                        window.prodmenuv3.close();
                        jQuery(".new_menu_v3 a").parent().removeClass("active");
                    }
                    window.northmenu = jQuery.fancybox.open(
                        {
                            src: "#northcollectionmenu",
                            type: "inline",
                            opts: {
                                touch: false,
                                autoFocus: false,
                                backFocus: false,
                                trapFocus: false,
                            },
                        },
                        {
                            baseClass: "customProductsFancy",
                            afterClose: function (instance, current, e) {
                                jQuery(".new_menu_north a")
                                    .parent()
                                    .removeClass("active");
                            },
                        }
                    );
                });
                if (jQuery(".video_player_home").length > 0) {
                    jQuery(".video_player_home").each(function (index, el) {
                        jQuery(this).get(0).play();
                    });
                }

                if (Cookies.get("gdpr_ok") == "ok") {
                    jQuery("#cookie_popup").remove();
                } else if (jQuery("#cookie_popup").length) {
                    if (Cookies.get("eu") != "nope") {
                        jQuery
                            .get({
                                url: "https://api.ipdata.co/is_eu/?api-key=9b41bdb57c8c3952caca181358633ad08855de14b0dc60336f881549",
                                data: false,
                                dataType: "JSON",
                            })
                            .done(function (data) {
                                if (data) {
                                    jQuery("#cookie_popup").addClass(
                                        "show_cookie"
                                    );
                                } else {
                                    Cookies.set("eu", "nope");
                                }
                            });
                    }
                }

                if (jQuery("#newsletter_pop").length) {
                    var cookies_news_id = jQuery("#newsletter_cookie_id").val();
                    if (Cookies.get(cookies_news_id) != "ok") {
                        var bg = jQuery("#newsletter_pop .content_news").css(
                                "background-image"
                            ),
                            bg = bg.replace(/(^url\()|(\)$|[\"\'])/g, "");
                        jQuery("<img/>")
                            .attr("src", bg)
                            .on("load", function () {
                                jQuery(this).remove();
                                jQuery(
                                    "#newsletter_pop #origin_newsletter"
                                ).val("Popup");
                                jQuery("#newsletter_pop").fadeIn(250);
                            });
                    } else {
                        jQuery("#newsletter_pop").remove();
                    }
                }

                run_animations();

                jQuery(window).trigger("site_loaded");

                jQuery("#close_pop_news").on("click", function (event) {
                    event.preventDefault();
                    close_news_popup();
                });

                // Remove empty P tags created by WP inside of Accordion and Orbit
                jQuery(".accordion p:empty, .orbit p:empty").remove();

                // Makes sure last grid item floats left
                jQuery(".archive-grid .columns").last().addClass("end");

                // Adds Flex Video to YouTube and Vimeo Embeds
                jQuery(
                    'iframe[src*="youtube.com"], iframe[src*="vimeo.com"]'
                ).each(function () {
                    if (
                        jQuery(this).innerWidth() / jQuery(this).innerHeight() >
                        1.5
                    ) {
                        jQuery(this).wrap(
                            "<div class='widescreen flex-video'/>"
                        );
                    } else {
                        jQuery(this).wrap("<div class='flex-video'/>");
                    }
                });

                if (jQuery(".scroller").length > 0) {
                    var ps = new PerfectScrollbar(".scroller", {
                        wheelPropagation: true,
                        suppressScrollX: true,
                    });

                    if (
                        jQuery(".scroller").children().height() <
                        jQuery(".scroller").height()
                    ) {
                        jQuery(".scroller").addClass("smaller_content");
                    }

                    jQuery("#root").on("resizeme.zf.trigger", function () {
                        if (
                            jQuery(".scroller").children().height() <
                            jQuery(".scroller").height()
                        ) {
                            jQuery(".scroller").addClass("smaller_content");
                        } else {
                            jQuery(".scroller").removeClass("smaller_content");
                        }
                    });
                }

                jQuery(".covervid").each(function (index, el) {
                    var $video = jQuery(this).find("video");
                    $video.coverVid(
                        $video.data("width"),
                        $video.data("height")
                    );
                });

                jQuery("#best_products > div").on("click", function (event) {
                    if (jQuery(this).data("link")) {
                        window.location.href = jQuery(this).data("link");
                        event.preventDefault();
                    }
                });

                jQuery("#subject").on("change", function (event) {
                    if (jQuery(this).val() != "") {
                        jQuery(this).addClass("active");
                    } else {
                        jQuery(this).removeClass("active");
                    }
                });

                jQuery("#country_select").on("change", function (event) {
                    if (jQuery(this).val() != "") {
                        jQuery(this).addClass("active");
                    } else {
                        jQuery(this).removeClass("active");
                    }
                });

                jQuery(".register_btn").on("click", function (event) {
                    event.preventDefault();
                    var type = jQuery(this).attr("id");
                    if (type == "show_password") {
                        jQuery(this)
                            .parent()
                            .find("input")
                            .attr("type", "text");
                        jQuery(this)
                            .hide()
                            .parent()
                            .find("#hide_password")
                            .show();
                    } else {
                        jQuery(this)
                            .parent()
                            .find("input")
                            .attr("type", "password");
                        jQuery(this)
                            .hide()
                            .parent()
                            .find("#show_password")
                            .show();
                    }
                });

                jQuery("body").on("scrollme.zf.trigger", function () {
                    if (
                        jQuery(window).scrollTop() >
                        jQuery(window).height() / 2
                    ) {
                        jQuery("#back_to_top").fadeIn(150);
                    } else {
                        jQuery("#back_to_top").fadeOut(150);
                    }
                });

                jQuery("#back_to_top").on("click", function (event) {
                    event.preventDefault();
                    jQuery("html, body").animate({ scrollTop: 0 }, 750);
                });

                jQuery("#footer .anchor > a").on("click", function (event) {
                    event.preventDefault();
                    return false;
                });

                jQuery("#scroll_down_video").on("click", function (event) {
                    event.preventDefault();
                    jQuery("html, body").animate(
                        { scrollTop: jQuery("#bg_video").height() + 100 },
                        750
                    );
                });

                if (jQuery("#scroll_down_video").length > 0) {
                    setTimeout(function () {
                        jQuery("#scroll_down_video").fadeOut(250);
                    }, 5000);
                }

                jQuery("#page-header #video_controls > div").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                        var video_id = jQuery(this).parent().data("id"),
                            video = document.getElementById(video_id);

                        jQuery(this).siblings().show();
                        if (jQuery(this).hasClass("play")) {
                            jQuery(this).hide();
                            video.play();
                        } else if (jQuery(this).hasClass("pause")) {
                            jQuery(this).hide();
                            video.pause();
                        }
                    }
                );

                jQuery("#page-header video").on("click", function (event) {
                    event.preventDefault();
                    if (jQuery(this).get(0).paused) {
                        jQuery("#page-header #video_controls .play").trigger(
                            "click"
                        );
                    } else {
                        jQuery("#page-header #video_controls .pause").trigger(
                            "click"
                        );
                    }
                });

                if (jQuery(".newsletter").length) {
                    var newsleter_form = document.querySelector(".newsletter");

                    newsleter_form.addEventListener(
                        "wpcf7mailsent",
                        function (event) {
                            gtag("event", "Signup", {
                                event_category: "Newsletter",
                                event_label:
                                    "Newsletter signup - " +
                                    site_vars.current_language,
                            });
                        },
                        false
                    );
                }
                if (jQuery(".newsletter_popup").length) {
                    var newsleter_form_pop =
                        document.querySelector(".newsletter_popup");

                    newsleter_form_pop.addEventListener(
                        "wpcf7mailsent",
                        function (event) {
                            close_news_popup();
                            gtag("event", "Signup", {
                                event_category: "Newsletter",
                                event_label:
                                    "Newsletter signup Popup - " +
                                    site_vars.current_language,
                            });
                        },
                        false
                    );
                }

                jQuery("#cookie_ok").on("click", function (event) {
                    event.preventDefault();
                    Cookies.set("gdpr_ok", "ok", { expires: 365 });
                    jQuery("#cookie_popup").addClass("remove_cookie");
                    setTimeout(function () {
                        jQuery("#cookie_popup").remove();
                    }, 1500);
                });

                jQuery("#no_translation_notice .close").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                        jQuery("#no_translation_notice").fadeOut(250);
                    }
                );

                if (jQuery("#country_select").length) {
                    var options = jQuery("select#country_select option").slice(
                        1
                    );
                    var arr = options
                        .map(function (_, o) {
                            return { t: $(o).text(), v: o.value };
                        })
                        .get();
                    arr.sort(function (o1, o2) {
                        return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0;
                    });

                    options.each(function (i, o) {
                        o.value = arr[i].v;
                        $(o).text(arr[i].t);
                    });
                }

                jQuery(".loadmore_posts").click(function () {
                    var button = jQuery(this),
                        data = {
                            action: "loadmore_posts",
                            query: loadmore_params.posts, // that's how we get params from wp_localize_script() function
                            page: loadmore_params.current_page,
                        };

                    jQuery.ajax({
                        // you can also use $.post here
                        url: loadmore_params.ajaxurl, // AJAX handler
                        data: data,
                        type: "POST",
                        beforeSend: function (xhr) {
                            button.text(button.data("loading")); // change the button text, you can also add a preloader image
                        },
                        success: function (data) {
                            if (data) {
                                button
                                    .text(button.data("more"))
                                    .parent()
                                    .before(data); // insert new posts
                                loadmore_params.current_page++;

                                window.codepoet.fadeInUp = appear({
                                    elements: function elements() {
                                        return document.getElementsByClassName(
                                            "fade_up_start"
                                        );
                                    },
                                    appear: function appear(el) {
                                        el.className += " fadeInUp animated";
                                    },
                                });

                                if (history.replaceState) {
                                    if (!window.codepoet.current_url_static) {
                                        window.codepoet.current_url_static =
                                            window.codepoet.current_url;
                                    }

                                    window.history.replaceState(
                                        {
                                            id:
                                                "news-page-" +
                                                loadmore_params.current_page,
                                        },
                                        document.title,
                                        window.codepoet.current_url_static +
                                            "page" +
                                            loadmore_params.current_page +
                                            "/"
                                    );
                                }

                                if (
                                    loadmore_params.current_page ==
                                    loadmore_params.max_page
                                ) {
                                    button.remove(); // if last page, remove the button
                                }
                            } else {
                                button.remove(); // if no data, remove the button as well
                            }
                        },
                    });
                });

                jQuery("#jobs_list_btn").on("click", function (event) {
                    event.preventDefault();
                    jQuery("html, body").animate(
                        { scrollTop: jQuery("#jobs_list").offset().top - 100 },
                        750
                    );
                });

                jQuery("#spontaneous_form_trigger").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                        jQuery("#spontaneous_form_trigger_original").trigger(
                            "click"
                        );
                    }
                );

                jQuery(".woocommerce-shipping-methods input").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                    }
                );

                jQuery(document.body).on(
                    "updated_checkout updated_cart_totals",
                    function () {
                        jQuery(".woocommerce-shipping-methods input").on(
                            "click",
                            function (event) {
                                event.preventDefault();
                            }
                        );
                    }
                );
                if (jQuery(".timeline_wraps").length) {
                    jQuery(".timeline_wraps .elements").css(
                        "margin-bottom",
                        jQuery(".timeline_wraps .main-elements .timeline")
                            .last()
                            .height()
                    );
                    jQuery(window).resize(function (event) {
                        jQuery(".timeline_wraps .elements").css(
                            "margin-bottom",
                            jQuery(".timeline_wraps .main-elements .timeline")
                                .last()
                                .height()
                        );
                    });
                }

                jQuery(".controls > div").on("click", function (event) {
                    event.preventDefault();
                    var video_id = jQuery(this).data("id"),
                        video = document.getElementById(video_id),
                        $current_parent = jQuery("#" + video_id + "_controls");

                    if (jQuery(this).hasClass("mute")) {
                        jQuery(this).hide();
                        $current_parent.find(".unmute").show();
                        video.muted = true;
                    } else if (jQuery(this).hasClass("unmute")) {
                        jQuery(this).hide();
                        $current_parent.find(".mute").show();
                        video.muted = false;
                    } else if (jQuery(this).hasClass("play")) {
                        jQuery(this).hide();
                        $current_parent.find(".pause").show();
                        video.play();
                    } else if (jQuery(this).hasClass("pause")) {
                        jQuery(this).hide();
                        $current_parent.find(".play").show();
                        video.pause();
                    } else if (jQuery(this).hasClass("reset")) {
                        video.currentTime = 0;
                    }
                });

                jQuery(".big_play").on("click", function (event) {
                    event.preventDefault();
                    jQuery(this)
                        .fadeOut(150)
                        .prev(".controls")
                        .fadeIn(150)
                        .find(".play")
                        .trigger("click");
                });

                if (jQuery("#popup_ecom").length) {
                    let ecom_news_id = jQuery("#ecom_cookie_id").val();
                    if (Cookies.get(ecom_news_id) != "ok") {
                        jQuery("#popup_ecom .next").on(
                            "click",
                            function (event) {
                                event.preventDefault();
                                window.codepoet.ecom_slider.goToNextSlide();
                            }
                        );

                        jQuery("#popup_ecom .close").on(
                            "click",
                            function (event) {
                                event.preventDefault();
                                jQuery.fancybox.close();
                            }
                        );

                        jQuery.fancybox.open({
                            src: "#popup_ecom",
                            type: "inline",
                            opts: {
                                touch: false,
                                autoFocus: false,
                                backFocus: false,
                                trapFocus: false,
                                helpers: {
                                    overlay: {
                                        closeClick: false,
                                    },
                                },
                                afterShow: function (instance, current) {
                                    window.codepoet.ecom_slider = jQuery(
                                        "#popup_ecom .popup_slider"
                                    ).bxSlider({
                                        mode: "horizontal",
                                        controls: false,
                                        pager: true,
                                        infiniteLoop: false,
                                        touchEnabled: false,
                                        adaptiveHeight: true,
                                        preventDefaultSwipeX: false,
                                        onSliderLoad: function (currentIndex) {
                                            jQuery("#popup_ecom").addClass(
                                                "loaded"
                                            );
                                        },
                                    });
                                },
                                afterClose: function () {
                                    window.codepoet.ecom_slider.destroySlider();
                                    let ecom_news_id =
                                        jQuery("#ecom_cookie_id").val();
                                    Cookies.set(ecom_news_id, "ok");
                                },
                            },
                        });
                    }
                }

                posts_carousel();
            },
        },
        home: {
            init: function () {
                if (jQuery(".bxslider").length) {
                    window.codepoet.home_slider = jQuery(".bxslider").bxSlider({
                        mode: "fade",
                        controls: false,
                        pager: false,
                        speed: 100,
                        pause: 10000,
                        touchEnabled: false,
                        onSliderLoad: function (currentIndex) {
                            jQuery(".covervid_slider").each(function (
                                index,
                                el
                            ) {
                                var $video = jQuery(this).find("video");
                                $video.coverVid(
                                    $video.data("width"),
                                    $video.data("height")
                                );
                            });

                            jQuery("#home_slider .slide")
                                .eq(currentIndex)
                                .addClass("active");
                        },
                        onSlideBefore: function (
                            $slideElement,
                            oldindex,
                            newindex
                        ) {
                            jQuery("#home_slider .slide")
                                .eq(oldindex)
                                .removeClass("active");
                            $slideElement.addClass("active");
                            if ($slideElement.hasClass("video")) {
                                window.codepoet.home_slider.stopAuto();
                                window.codepoet.home_slider_auto_started = false;
                                $slideElement
                                    .find("video")
                                    .addClass("active")
                                    .get(0)
                                    .play();
                            }
                        },
                        onSlideAfter: function (
                            $slideElement,
                            oldindex,
                            newindex
                        ) {
                            if ($slideElement.hasClass("video")) {
                                window.codepoet.home_slider.stopAuto();
                                window.codepoet.home_slider_auto_started = false;
                                if (
                                    window.codepoet.home_slider.getSlideCount() >
                                    1
                                ) {
                                    $slideElement
                                        .find("video")
                                        .on("ended", function (event) {
                                            $slideElement
                                                .find("video")
                                                .removeClass("active")
                                                .get(0)
                                                .pause();
                                            $slideElement
                                                .find("video")
                                                .get(0).currentTime = 0;
                                            $slideElement
                                                .find("video")
                                                .off("ended");
                                            window.codepoet.home_slider.goToNextSlide();
                                        });
                                }
                            } else {
                                if (!window.codepoet.home_slider_auto_started) {
                                    window.codepoet.home_slider.startAuto();
                                    window.codepoet.home_slider_auto_started = true;
                                }
                            }
                        },
                    });

                    slider_home_loaded();
                }

                jQuery(".link_slider a.anchor").on("click", function (event) {
                    event.preventDefault();
                    jQuery("html, body").animate(
                        {
                            scrollTop:
                                jQuery(jQuery(this).attr("href")).offset().top -
                                100,
                        },
                        750
                    );
                });

                awards_section();

                jQuery("#root").on("resizeme.zf.trigger", function () {
                    awards_section();
                });

                window.codepoet.video_carousel = jQuery(
                    ".section6_slider"
                ).bxSlider({
                    mode: "fade",
                    controls: false,
                    pager: false,
                    touchEnabled: false,
                    infiniteLoop: false,
                    adaptiveHeight: true,
                    onSliderLoad: function (currentIndex) {
                        jQuery(".section6_slider .slide")
                            .eq(currentIndex)
                            .find("video")
                            .get(0)
                            .play();
                    },
                    onSlideBefore: function (
                        $slideElement,
                        oldindex,
                        newindex
                    ) {
                        jQuery(".video_player_carousel").each(function (
                            index,
                            el
                        ) {
                            jQuery(this).get(0).pause();
                            jQuery(this).get(0).currentTime = 0;
                            var $controls_id = jQuery(
                                "#" + jQuery(this).attr("id") + "_controls"
                            );
                            $controls_id.find(".pause").show();
                            $controls_id.find(".play").hide();
                        });
                        jQuery(".section6_slider .slide")
                            .eq(newindex)
                            .find("video")
                            .get(0)
                            .play();
                    },
                });

                jQuery(".section6_slider .pager_wrap a").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                        var index = jQuery(this).data("index");
                        jQuery(".section6_slider .pager_wrap li").removeClass(
                            "active"
                        );
                        jQuery(
                            '.section6_slider .pager_wrap a[data-index="' +
                                index +
                                '"]'
                        )
                            .parent()
                            .addClass("active");
                        window.codepoet.video_carousel.goToSlide(index);
                    }
                );

                if (jQuery("#elevate_header").length) {
                    var video_elevate =
                            document.getElementById("video_elevate"),
                        videoElevateUrl = "",
                        req = new XMLHttpRequest();

                    if (
                        video_elevate.getAttribute("data-mobile") != "" &&
                        jQuery(window).width() < 1024
                    ) {
                        videoElevateUrl =
                            video_elevate.getAttribute("data-mobile");
                    } else {
                        videoElevateUrl =
                            video_elevate.getAttribute("data-video");
                    }

                    var checkVideoElevateStatus = setInterval(function () {
                        if (video_elevate.readyState > 3) {
                            req.abort();
                            window.codepoet.videoElevate = true;
                            clearInterval(checkVideoElevateStatus);
                            site_loading(true);
                        }
                    }, 100);

                    req.addEventListener("progress", updateProgress);
                    req.addEventListener("load", transferComplete);
                    req.addEventListener("error", transferFailed);
                    req.addEventListener("abort", transferCanceled);
                    req.open("GET", videoElevateUrl, true);
                    req.responseType = "blob";

                    req.onload = function () {
                        if (this.status === 200) {
                            var videoBlob = this.response;
                            var vid = URL.createObjectURL(videoBlob); // IE10+
                            video_elevate.src = vid;
                            window.codepoet.videoElevate = true;
                            video_elevate.play();
                        }
                    };

                    req.send();

                    video_elevate.addEventListener(
                        "ended",
                        function () {
                            jQuery("#elevate_header .link").addClass("active");
                        },
                        false
                    );
                }

                jQuery(".entry-content-wrap .content").readmore({
                    speed: 75,
                    moreLink:
                        '<a href="#" class="read-more-home"><span><i class="fas fa-angle-down"></i> ' +
                        site_vars.read_more +
                        "</span></a>",
                    lessLink: false,
                    collapsedHeight: 400,
                });

                if (jQuery("#elevate_themes").length) {
                    get_elevate_themes();
                }
            },
        },
        pregister: {
            init: function () {
                login_buttons();
                if (jQuery("#serial_number_check input").length > 0) {
                    var serial_number = document.querySelector(
                        "#serial_number_check input"
                    );
                    var serial_number_mask = new IMask(serial_number, {
                        mask: [
                            {
                                mask: "a00000000",
                            },
                            {
                                mask: "aa0000000000aa",
                            },
                            {
                                mask: "000a00000000",
                            },
                        ],
                    });
                    jQuery("#serial_number_check input").focusout(function (
                        event
                    ) {
                        jQuery(this).val(jQuery(this).val().toUpperCase());
                    });
                }
                var checkboxes = jQuery("input[type=checkbox]");

                checkboxes.each(function () {
                    $(this).wrap('<div class="customCheckbox"></div>');
                    $(this).before("<span>&#10004;</span>");
                });

                checkboxes.change(function () {
                    if ($(this).is(":checked")) {
                        $(this).parent().addClass("customCheckboxChecked");
                    } else {
                        $(this).parent().removeClass("customCheckboxChecked");
                    }
                });
            },
        },
        productpage: {
            init: function () {
                var $ajax_price = jQuery("#ajax_price");
                if ($ajax_price.data("variationsdata") != "") {
                    jQuery(".variations_form")
                        .data(
                            "product_variations",
                            $ajax_price.data("variationsdata")
                        )
                        .trigger("reload_product_variations");
                }
                var $promo = jQuery("#promo");
                jQuery
                    .ajax({
                        url:
                            site_vars.root +
                            "codepoet/v1/products/product_promo/" +
                            $promo.data("id"),
                        type: "GET",
                        dataType: "json",
                    })
                    .done(function (data) {
                        if (data) {
                            jQuery("#promo")
                                .html('<img src="' + data + '" />')
                                .fadeIn(250);
                        }
                    })
                    .fail(function () {
                        console.log("error");
                    });
                jQuery(".single_variation_wrap").on(
                    "show_variation",
                    function (event, variation) {
                        var price = variation.price_html;
                        jQuery("#ajax_price")
                            .html(price)
                            .parent()
                            .addClass("active")
                            .find(".from")
                            .css("opacity", 0);
                    }
                );

                jQuery("#video_product_play").on("click", function (event) {
                    event.preventDefault();
                    jQuery(this)
                        .fadeOut(150)
                        .prev("video")
                        .attr("controls", "true")
                        .get(0)
                        .play();
                });

                jQuery(".images .woocommerce-product-gallery__image")
                    .eq(0)
                    .find("img")
                    .on("load", function () {
                        jQuery(".woocommerce-product-gallery").resize();
                    });
                jQuery(".woocommerce-product-gallery__wrapper a").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                    }
                );
                jQuery(".tab_title").on("click", function (event) {
                    event.preventDefault();
                    if (!jQuery(this).hasClass("active")) {
                        var new_tab = jQuery(this).data("tab");
                        jQuery(this)
                            .siblings(".tab_title")
                            .removeClass("active");
                        jQuery(this).addClass("active");
                        jQuery("#" + new_tab)
                            .siblings(".tab_content")
                            .removeClass("active")
                            .hide();
                        jQuery("#" + new_tab)
                            .addClass("active")
                            .fadeIn(250);
                    }
                });

                jQuery(".bxslider").bxSlider({
                    mode: "fade",
                    controls: false,
                    pager: true,
                    auto: true,
                });

                jQuery("#close_add_to_cart_bar").on("click", function (event) {
                    event.preventDefault();
                    jQuery("#add_to_cart_bar").removeClass("active");
                    jQuery("#buy_now_floater").show();
                });

                jQuery("#buy_now_floater").on("click", function (event) {
                    event.preventDefault();
                    jQuery(this).hide();
                    jQuery("#add_to_cart_bar").addClass("active");
                });

                jQuery(".load_more").each(function (index, el) {
                    let height = jQuery(el).data("loadmoreheight")
                        ? jQuery(el).data("loadmoreheight")
                        : 360;
                    jQuery(el).readmore({
                        speed: 75,
                        moreLink:
                            '<a href="#"><i class="fas fa-angle-down"></i> ' +
                            site_vars.specs_more +
                            "</a>",
                        lessLink: false,
                        collapsedHeight: height,
                    });
                });

                var $product = jQuery(".product"),
                    $product_gallery = $product.find(".images"),
                    $gallery_nav = $product.find(".flex-control-nav"),
                    $gallery_img = $gallery_nav.find("li:eq(0) img"),
                    $product_img_wrap = $product_gallery
                        .find(
                            ".woocommerce-product-gallery__image, .woocommerce-product-gallery__image--placeholder"
                        )
                        .eq(0),
                    $product_img = $product_img_wrap.find("img");
                $product_img.addClass("wp-post-image");

                jQuery(".variations_form").tawcvs_variation_swatches_form();

                jQuery(document.body).trigger("tawcvs_initialized");

                jQuery("body").trigger("scrollme.zf.trigger");

                if (isMobile) {
                    jQuery(".single-product #split_sections .column").click(
                        function () {
                            jQuery(
                                ".single-product #split_sections .column"
                            ).removeClass("hovered");
                            jQuery(this).addClass("hovered");
                        }
                    );
                } else {
                    jQuery(".single-product #split_sections .column").hover(
                        function () {
                            jQuery(this).addClass("hovered");
                        },
                        function () {
                            jQuery(this).removeClass("hovered");
                        }
                    );
                }

                jQuery("#add_to_cart_bar .in_store").on(
                    "click",
                    function (event) {
                        gtag("event", "Click", {
                            event_category: "Try In Store",
                            event_label: jQuery(
                                "#add_to_cart_bar .title"
                            ).text(),
                        });
                    }
                );

                jQuery(".try_in_store_header .in_store").on(
                    "click",
                    function (event) {
                        gtag("event", "Click", {
                            event_category: "Try In Store",
                            event_label: jQuery("#page-header h1").text(),
                        });
                    }
                );

                if (jQuery("#split_sections_v3").length) {
                    let split_sections_v3_slick_settings = {
                        infinite: false,
                        autoplay: false,
                        arrows: true,
                        nextArrow:
                            '<button type="button" class="slick-next"><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMjI0MTggMTQuMzMzOUMxMC44MjI5IDExLjc4MjUgMTMuMTc4OSA5LjQgMTUuNDc0NiA3LjE2N0MxMi44NzQ4IDQuNjE5OTIgMTAuNTE3NiAyLjIyOTk1IDguMjI0MTkgNC42MDk2MmUtMDVDNy42MjY5NCAwLjU4MDgyMSA3LjE3NjggMS4wMjc2NSA2LjYwNTkyIDEuNTgzMThDOC4xNTcyMSAzLjExOTEgOS43NjAyMiA0LjcwODgyIDExLjEwNjIgNi4wNDE1OUwxLjQyNTE5IDYuMDQxNTlDMS4xMjg3NiA2LjA0MTU5IDAuODU5NzkzIDYuMzA5NDcgMC44NTk3OTMgNi42MDQ4TDAuODU5NzkzIDcuNzMwMTJDMC44NTk3OTMgOC4wMjQzNiAxLjEyOTg3IDguMjkzMzMgMS40MjUxOSA4LjI5MzMzTDExLjEwNjIgOC4yOTMzM0M5LjYwMSA5Ljc3MjE3IDguMTE3NzIgMTEuMjcyIDYuNjA1OTIgMTIuNzQzQzcuMTQ5MzcgMTMuMjg1NCA3Ljc0NjYxIDEzLjg2MDcgOC4yMjQxOCAxNC4zMzVMOC4yMjQxOCAxNC4zMzM5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==" /></button>',
                        prevArrow:
                            '<button type="button" class="slick-prev"><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMjI0MTggMTQuMzMzOUMxMC44MjI5IDExLjc4MjUgMTMuMTc4OSA5LjQgMTUuNDc0NiA3LjE2N0MxMi44NzQ4IDQuNjE5OTIgMTAuNTE3NiAyLjIyOTk1IDguMjI0MTkgNC42MDk2MmUtMDVDNy42MjY5NCAwLjU4MDgyMSA3LjE3NjggMS4wMjc2NSA2LjYwNTkyIDEuNTgzMThDOC4xNTcyMSAzLjExOTEgOS43NjAyMiA0LjcwODgyIDExLjEwNjIgNi4wNDE1OUwxLjQyNTE5IDYuMDQxNTlDMS4xMjg3NiA2LjA0MTU5IDAuODU5NzkzIDYuMzA5NDcgMC44NTk3OTMgNi42MDQ4TDAuODU5NzkzIDcuNzMwMTJDMC44NTk3OTMgOC4wMjQzNiAxLjEyOTg3IDguMjkzMzMgMS40MjUxOSA4LjI5MzMzTDExLjEwNjIgOC4yOTMzM0M5LjYwMSA5Ljc3MjE3IDguMTE3NzIgMTEuMjcyIDYuNjA1OTIgMTIuNzQzQzcuMTQ5MzcgMTMuMjg1NCA3Ljc0NjYxIDEzLjg2MDcgOC4yMjQxOCAxNC4zMzVMOC4yMjQxOCAxNC4zMzM5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==" /></button>',
                        dots: false,
                        rows: 0,
                        draggable: true,
                        slidesToShow: 2.75,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 1399,
                                settings: {
                                    arrows: true,
                                    slidesToShow: 2.1,
                                    slidesToScroll: 1,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    arrows: false,
                                    slidesToShow: 1.1,
                                    slidesToScroll: 1,
                                },
                            },
                        ],
                    };
                    jQuery(".split_sections_slider").slick(
                        split_sections_v3_slick_settings
                    );
                }

                if (jQuery(".lifestyle").length) {
                    var $lifestyle = jQuery(".lifestyle").slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        cssEase: "linear",
                        slidesToShow: 1.1,
                    });

                    jQuery(".liftstyle_captions .lifestyle_caption")
                        .eq(0)
                        .addClass("active")
                        .fadeIn(250);

                    $lifestyle.on(
                        "afterChange",
                        function (event, slick, currentSlide) {
                            var i = (currentSlide ? currentSlide : 0) + 1,
                                count = slick.slideCount,
                                percentage = (i / count) * 100;
                            jQuery(".lifestyle_progressbar .progress").css(
                                "width",
                                percentage + "%"
                            );
                            jQuery(
                                ".liftstyle_captions .lifestyle_caption.active"
                            )
                                .removeClass("active")
                                .fadeOut(150, function () {
                                    jQuery(
                                        ".liftstyle_captions .lifestyle_caption"
                                    )
                                        .eq(currentSlide)
                                        .addClass("active")
                                        .fadeIn(250);
                                });
                        }
                    );
                }
                if (jQuery("#product-title").length) {
                    jQuery("#product-title")
                        .contents()
                        .filter(function () {
                            return this.nodeType === 3;
                        })
                        .wrap("<div></div>")
                        .end()
                        .filter("br")
                        .remove();
                }
                if (jQuery("#shares").length) {
                    jQuery("#shares").jsSocials({
                        showCount: false,
                        showLabel: false,
                        shares: [
                            {
                                share: "facebook",
                                logo: "fab fa-facebook-f",
                                css: "black-share",
                            },
                            {
                                share: "twitter",
                                logo: "fab fa-twitter",
                                css: "black-share",
                            },
                            {
                                share: "linkedin",
                                logo: "fab fa-linkedin-in",
                                css: "black-share",
                            },
                            {
                                share: "email",
                                logo: "fas fa-envelope",
                                css: "black-share",
                            },
                        ],
                    });
                }
            },
        },
        woocommerce_checkout: {
            init: function () {
                if (jQuery("#wc_realex_redirect_iframe_form").length) {
                    setTimeout(function () {
                        jQuery("body").unblock();
                    }, 250);
                }
                jQuery(".next_step").on("click", function (event) {
                    event.preventDefault();
                    var id = jQuery(this).data("id"),
                        current = jQuery(this).data("current"),
                        $current_section = jQuery(".checkout_" + current),
                        $next_section = jQuery(".checkout_" + id),
                        current_content = "",
                        validation = true,
                        continueChecks = true,
                        $required_inputs =
                            $current_section.find(".validate-required"),
                        current_shipping_type = jQuery(".shipping_choices")
                            .first()
                            .find("input:checked")
                            .attr("name"),
                        current_selected_store_id =
                            jQuery("#store_selected_id").val();

                    if ($required_inputs.length) {
                        if (current == "shipping") {
                            continueChecks = false;
                            if (
                                jQuery(
                                    "#ship-to-different-address-checkbox"
                                ).is(":checked")
                            ) {
                                continueChecks = true;
                            }
                        }

                        if (continueChecks) {
                            $required_inputs.each(function () {
                                if (!jQuery(this).is(":hidden")) {
                                    if (
                                        jQuery(this)
                                            .find("input.input-text")
                                            .val() === "" ||
                                        jQuery(this).hasClass(
                                            "woocommerce-invalid"
                                        )
                                    ) {
                                        validation = false;
                                        jQuery(this).addClass(
                                            "woocommerce-invalid"
                                        );
                                    } else if (
                                        jQuery(this).find("select").val() === ""
                                    ) {
                                        validation = false;
                                        jQuery(this).addClass(
                                            "woocommerce-invalid"
                                        );
                                    } else {
                                        jQuery(this).removeClass(
                                            "woocommerce-invalid"
                                        );
                                    }
                                }
                            });
                        }
                        if (current == "shipping") {
                            if (current_selected_store_id == "") {
                                if (current_shipping_type == "ship_to_store") {
                                    jQuery("#location_search input").addClass(
                                        "error"
                                    );
                                } else {
                                    jQuery(
                                        "#location_search_normal input"
                                    ).addClass("error");
                                }
                                validation = false;
                            }
                        }
                    }
                    if (validation) {
                        if (current == "shipping") {
                            var current_selected_store_content = "";
                            current_content +=
                                '<div class="' +
                                current +
                                '"><div class="title-main-ship">' +
                                window["site_vars"][
                                    current_shipping_type + "_title"
                                ] +
                                "</div>";
                            $current_section
                                .addClass("edit-active")
                                .removeClass("active");
                            if (current_shipping_type == "ship_to_store") {
                                current_selected_store_content = jQuery(
                                    "#ship-to-store .choice_result span"
                                ).html();
                                current_content +=
                                    '<div class="selected_store_ship_to">' +
                                    current_selected_store_content +
                                    "</div>";
                            } else {
                                current_selected_store_content = jQuery(
                                    "#store_selector_normal .choice_result_normal span"
                                ).html();
                                var $search_section = $current_section;
                                if (
                                    current_shipping_type ==
                                    "ship_to_same_address"
                                ) {
                                    var $search_section =
                                        jQuery(".checkout_billing");
                                }
                                $search_section
                                    .find(".form-row")
                                    .each(function (index, el) {
                                        if (
                                            jQuery(el).find(
                                                'input[type="text"]'
                                            ).length
                                        ) {
                                            var textInput =
                                                jQuery(el).find(
                                                    'input[type="text"]'
                                                );
                                            current_content +=
                                                '<div class="' +
                                                textInput.attr("name") +
                                                '">' +
                                                textInput.val() +
                                                "</div>";
                                        } else if (
                                            jQuery(el).find("select").length
                                        ) {
                                            var selectInput =
                                                jQuery(el).find("select");
                                            current_content +=
                                                '<div class="' +
                                                selectInput.attr("name") +
                                                '">' +
                                                selectInput
                                                    .find("option:selected")
                                                    .text() +
                                                "</div>";
                                        }
                                    });
                            }

                            current_content +=
                                '<div class="selected_store_content"><div class="store-title">' +
                                site_vars.shop_service_title +
                                '</div><div class="content_selected_store">' +
                                current_selected_store_content +
                                "</div></div>";
                            current_content += "</div>";
                        } else if (current == "billing") {
                            $current_section
                                .addClass("edit-active")
                                .removeClass("active")
                                .find(".form-row")
                                .each(function (index, el) {
                                    if (
                                        jQuery(el).find('input[type="text"]')
                                            .length
                                    ) {
                                        var textInput =
                                            jQuery(el).find(
                                                'input[type="text"]'
                                            );
                                        current_content +=
                                            '<div class="' +
                                            textInput.attr("name") +
                                            '">' +
                                            textInput.val() +
                                            "</div>";
                                    } else if (
                                        jQuery(el).find("select").length
                                    ) {
                                        var selectInput =
                                            jQuery(el).find("select");
                                        current_content +=
                                            '<div class="' +
                                            selectInput.attr("name") +
                                            '">' +
                                            selectInput
                                                .find("option:selected")
                                                .text() +
                                            "</div>";
                                    } else if (
                                        jQuery(el).find(
                                            'input[type="tel"], input[type="email"]'
                                        ).length
                                    ) {
                                        var textInput =
                                            jQuery(el).find("input");
                                        current_content +=
                                            '<div class="' +
                                            textInput.attr("name") +
                                            '">' +
                                            textInput.val() +
                                            "</div>";
                                    }
                                });
                        }

                        $current_section
                            .find(".current_content")
                            .html(current_content);
                        $next_section
                            .addClass("active")
                            .removeClass("edit-active");
                        jQuery("html, body").animate(
                            {
                                scrollTop: $next_section.offset().top - 100,
                            },
                            750
                        );

                        if (current == "billing") {
                            jQuery(".shipping_choices input:checked").trigger(
                                "click"
                            );
                        }
                    } else {
                        var offset_to_first_error = 0;
                        if (
                            $current_section.find(".woocommerce-invalid").length
                        ) {
                            offset_to_first_error = $current_section
                                .find(".woocommerce-invalid")
                                .first()
                                .offset().top;
                        } else {
                            offset_to_first_error =
                                $current_section.offset().top;
                        }

                        jQuery("html, body").animate(
                            { scrollTop: offset_to_first_error - 100 },
                            750
                        );
                    }
                });

                jQuery(".edit").on("click", function (event) {
                    event.preventDefault();
                    var id = jQuery(this).data("id");
                    jQuery(".checkout_section").removeClass("active");
                    jQuery(".checkout_" + id)
                        .removeClass("edit-active")
                        .addClass("active");
                });

                jQuery('.shipping_choices input[type="radio"]').on(
                    "click",
                    function (event) {
                        jQuery(this).parent().parent().addClass("active");
                        jQuery(".shipping_choices input")
                            .not(this)
                            .prop("checked", false)
                            .trigger("change")
                            .parent()
                            .parent()
                            .removeClass("active");
                        if (
                            jQuery(this).attr("name") ==
                            "ship_to_different_address"
                        ) {
                            setTimeout(function () {
                                jQuery(".shipping_address").addClass("active");
                            }, 250);
                        } else {
                            jQuery(".shipping_address").removeClass("active");
                        }
                        if (jQuery(this).attr("name") == "ship_to_store") {
                            jQuery(
                                '#order_review .woocommerce-shipping-methods input[value^="local_pickup"]'
                            )
                                .prop("checked", true)
                                .trigger("change");
                            jQuery("#store_selector_normal").hide();
                            if (
                                jQuery("#ship-to-store .choice_result").data(
                                    "storeid"
                                )
                            ) {
                                jQuery("#store_selected_id").val(
                                    jQuery(
                                        "#ship-to-store .choice_result"
                                    ).data("storeid")
                                );
                            } else {
                                jQuery("#store_selected_id").val("");
                            }
                        } else {
                            jQuery(
                                '#order_review .woocommerce-shipping-methods input[value^="wf_shipping_ups"]'
                            )
                                .prop("checked", true)
                                .trigger("change");
                            setTimeout(function () {
                                jQuery(
                                    '#order_review .woocommerce-shipping-methods input[value^="per_product"]'
                                )
                                    .prop("checked", true)
                                    .trigger("change");
                            }, 150);
                            jQuery("#store_selector_normal").show();
                            if (
                                jQuery(
                                    "#store_selector_normal .choice_result_normal"
                                ).data("storeid")
                            ) {
                                jQuery("#store_selected_id").val(
                                    jQuery(
                                        "#store_selector_normal .choice_result_normal"
                                    ).data("storeid")
                                );
                            } else {
                                jQuery("#store_selected_id").val("");
                            }
                        }
                    }
                );

                jQuery(
                    "#radius_search select, #radius_search_normal select"
                ).html(jQuery("#wpsl-radius-dropdown").html());

                jQuery(
                    "#location_search input, #location_search_normal input"
                ).blur(function (event) {
                    jQuery(this).removeClass("error");
                    jQuery("#wpsl-search-input").val(jQuery(this).val());
                    if (jQuery(this).val() == "") {
                        jQuery(this).addClass("error");
                    }
                });

                jQuery(
                    "#location_search input, #location_search_normal input"
                ).on("keyup", function (event) {
                    if (event.keyCode === 13) {
                        var parent = jQuery(this).parent().attr("id");
                        if (parent == "location_search") {
                            jQuery("#trigger_store_search").trigger("click");
                        } else {
                            jQuery("#trigger_store_search_normal").trigger(
                                "click"
                            );
                        }
                    }
                });

                jQuery("#radius_search select").on("change", function (event) {
                    jQuery(
                        "#wpsl-radius-dropdown, #radius_search_normal select"
                    ).val(jQuery(this).val());
                });

                jQuery("#radius_search_normal select").on(
                    "change",
                    function (event) {
                        jQuery(
                            "#wpsl-radius-dropdown, #radius_search select"
                        ).val(jQuery(this).val());
                    }
                );

                jQuery("#edit_store_search a, #edit_store_search_normal a").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                        var button_type = jQuery(this).data("type"),
                            choice_content = ".choice_content";
                        if (button_type == "select_your_store") {
                            choice_content = ".choice_content_normal";
                        }
                        jQuery(this)
                            .parent()
                            .parent()
                            .removeClass("active")
                            .parent()
                            .find(choice_content)
                            .removeClass("hide");
                    }
                );

                jQuery(
                    "#trigger_store_search, #trigger_store_search_normal"
                ).on("click", function (event) {
                    event.preventDefault();
                    var button_type = jQuery(this).data("type");
                    window.codepoet.checkout_store_search_btn = button_type;
                    if (button_type == "ship_to_store") {
                        if (jQuery("#location_search input").val() == "") {
                            jQuery("#location_search input").addClass("error");
                            return false;
                        }
                    } else {
                        if (
                            jQuery("#location_search_normal input").val() == ""
                        ) {
                            jQuery("#location_search_normal input").addClass(
                                "error"
                            );
                            return false;
                        }
                    }
                    jQuery.fancybox.open({
                        src: "#store_selector_map",
                        type: "inline",
                        opts: {
                            touch: false,
                            autoFocus: false,
                            backFocus: false,
                            trapFocus: false,
                            afterClose: function () {
                                window.codepoet.is_wpsl_pop = false;
                            },
                            afterShow: function (instance, current) {
                                jQuery("#wpsl-search-btn").trigger("click");
                                window.codepoet.is_wpsl_pop = true;
                                if (
                                    !window.codepoet
                                        .initialized_select_store_btn
                                ) {
                                    jQuery(document).ajaxSend(function (
                                        event,
                                        jqxhr,
                                        settings
                                    ) {
                                        if (window.codepoet.is_wpsl_pop) {
                                            var param = getParameterByName(
                                                "action",
                                                settings.url
                                            );
                                            if (param == "store_search") {
                                                var url = new URL(settings.url);
                                                url.searchParams.set(
                                                    "is_checkout",
                                                    "yes"
                                                );
                                                settings.url = url;
                                            }
                                        }
                                    });

                                    jQuery(document).ajaxComplete(function (
                                        event,
                                        xhr,
                                        settings
                                    ) {
                                        var param = getParameterByName(
                                            "action",
                                            settings.url
                                        );
                                        if (param == "store_search") {
                                            window.codepoet.initialized_select_store_btn = true;
                                            jQuery(".select_store_btn").on(
                                                "click",
                                                function (event) {
                                                    event.preventDefault();
                                                    var id =
                                                        jQuery(this).data("id");
                                                    jQuery(
                                                        "#store_selected_id"
                                                    ).val(id);
                                                    if (
                                                        window.codepoet
                                                            .checkout_store_search_btn ==
                                                        "ship_to_store"
                                                    ) {
                                                        jQuery(
                                                            "#ship-to-store .choice_content"
                                                        ).addClass("hide");
                                                        jQuery(
                                                            "#ship-to-store .choice_result"
                                                        )
                                                            .data("storeid", id)
                                                            .addClass("active")
                                                            .find("span")
                                                            .html(
                                                                jQuery(
                                                                    "#store-" +
                                                                        id +
                                                                        " .map_left"
                                                                ).html()
                                                            );
                                                    } else {
                                                        jQuery(
                                                            "#store_selector_normal .choice_content_normal"
                                                        ).addClass("hide");
                                                        jQuery(
                                                            "#store_selector_normal .choice_result_normal"
                                                        )
                                                            .data("storeid", id)
                                                            .addClass("active")
                                                            .find("span")
                                                            .html(
                                                                jQuery(
                                                                    "#store-" +
                                                                        id +
                                                                        " .map_left"
                                                                ).html()
                                                            );
                                                    }
                                                    jQuery.fancybox.close();
                                                }
                                            );
                                        }
                                    });
                                }
                            },
                        },
                    });
                });
            },
        },
        mainshop: {
            init: function () {
                if (jQuery(window).width() >= 1024) {
                    jQuery("#main_shop_page .first").wrapAll(
                        "<div class='left_column' />"
                    );
                    jQuery("#main_shop_page .last").wrapAll(
                        "<div class='right_column' />"
                    );
                } else {
                    jQuery(".description").readmore({
                        speed: 75,
                        moreLink:
                            '<a href="#"><i class="fas fa-angle-down"></i> ' +
                            site_vars.read_more +
                            "</a>",
                        lessLink: false,
                        collapsedHeight: 115,
                        beforeToggle: function (trigger, element, expanded) {
                            element.addClass("active");
                        },
                    });
                }

                jQuery("#root").on("resizeme.zf.trigger", function () {
                    if (jQuery(window).width() >= 1024) {
                        if (jQuery(".left_column").length == 0) {
                            jQuery("#main_shop_page .first").wrapAll(
                                "<div class='left_column' />"
                            );
                            jQuery("#main_shop_page .last").wrapAll(
                                "<div class='right_column' />"
                            );
                        }
                        jQuery(".description").readmore("destroy");
                    } else {
                        jQuery(".left_column > li").unwrap();
                        jQuery(".right_column > li").unwrap();
                        jQuery(".description").readmore({
                            speed: 75,
                            moreLink:
                                '<a href="#"><i class="fas fa-angle-down"></i> ' +
                                site_vars.read_more +
                                "</a>",
                            lessLink: false,
                            collapsedHeight: 115,
                            beforeToggle: function (
                                trigger,
                                element,
                                expanded
                            ) {
                                element.addClass("active");
                            },
                        });
                    }
                });
            },
        },
        singlepost: {
            init: function () {
                if (jQuery(".marquee").length) {
                    jQuery(".marquee").marquee();
                }
                jQuery("#shares").jsSocials({
                    showCount: false,
                    showLabel: true,
                    shares: [
                        {
                            share: "facebook",
                            logo: "fab fa-facebook-f",
                            css: "small-icon",
                            label: site_vars.share,
                        },
                        {
                            share: "twitter",
                            logo: "fab fa-twitter",
                            css: "small-icon",
                            label: site_vars.tweet,
                        },
                        {
                            share: "linkedin",
                            logo: "fab fa-linkedin-in",
                            css: "small-icon",
                            label: site_vars.share,
                        },
                        {
                            share: "googleplus",
                            logo: "fab fa-google-plus-g",
                            css: "small-icon",
                            label: site_vars.share,
                        },
                    ],
                });
            },
        },
        myaccount: {
            init: function () {
                login_buttons();
                jQuery("#change_password_now").on("click", function (event) {
                    event.preventDefault();
                    jQuery(this)
                        .parent()
                        .fadeOut(150, function () {
                            jQuery(".hide_password_open").fadeIn(250);
                        });
                });
                jQuery("form").submit(function (event) {
                    jQuery(this).addClass("loading");
                });
                jQuery(".mobile_buttons a").on("click", function (event) {
                    event.preventDefault();
                    var $id = jQuery(this).attr("href");
                    if (jQuery(this).hasClass("active")) {
                        jQuery(this).removeClass("active");
                        jQuery(".mobile_buttons a").removeClass("inactive");
                        jQuery($id).removeClass("active");
                    } else {
                        jQuery('.mobile_buttons a:not([href="' + $id + '"])')
                            .removeClass("inactive active")
                            .addClass("inactive");
                        jQuery(this).addClass("active");
                        jQuery($id)
                            .addClass("active")
                            .siblings()
                            .removeClass("active");
                        jQuery("html, body").animate(
                            { scrollTop: jQuery($id).offset().top + 50 },
                            750
                        );
                    }
                });
                if (jQuery(".order .description .content").length) {
                    jQuery(".order .description .content").readmore({
                        speed: 75,
                        moreLink:
                            '<a href="#" class="read-more-home"><span><i class="fas fa-angle-down"></i> ' +
                            site_vars.read_more +
                            "</span></a>",
                        lessLink: false,
                        collapsedHeight: 300,
                    });
                }
            },
        },
        guides: {
            init: function () {
                window.codepoet.guides_html = jQuery("#guide").html();

                if (site_vars.current_post_type == "guides") {
                    load_guide(jQuery("#guide").data("id"), false);
                } else {
                    jQuery(".guide_wrap").addClass("loading");

                    jQuery
                        .ajax({
                            url: site_vars.root + "codepoet/v1/guides",
                            data: {
                                lang: site_vars.current_language,
                            },
                        })
                        .done(function (data) {
                            window.codepoet.guides = data;

                            jQuery(window.codepoet.guides).each(function (
                                index,
                                el
                            ) {
                                var image = false,
                                    year_value = "",
                                    cats_value = "";

                                if (el.image) {
                                    image = el.image;
                                }

                                // Autocomplete data
                                var guide = {
                                    id: el.id,
                                    title: el.title,
                                    model: el.model,
                                    image: image,
                                };
                                window.codepoet.guides_autocomplete.push(guide);

                                // dropdowns data

                                if (
                                    el.category.term_id in
                                    window.codepoet.guides_select.cats
                                ) {
                                    cats_value =
                                        window.codepoet.guides_select.cats[
                                            el.category.term_id
                                        ].filter +
                                        " " +
                                        "product-" +
                                        el.id;
                                    window.codepoet.guides_select.cats[
                                        el.category.term_id
                                    ].filter = cats_value;
                                } else {
                                    cats_value = {
                                        title: el.category.name,
                                        filter: "product-" + el.id,
                                    };
                                    window.codepoet.guides_select.cats[
                                        el.category.term_id
                                    ] = cats_value;
                                }

                                if (
                                    !(
                                        el.year in
                                        window.codepoet.guides_select.years
                                    )
                                ) {
                                    year_value = {
                                        title: el.year,
                                        filter: "cat-" + el.category.term_id,
                                    };
                                    window.codepoet.guides_select.years[
                                        el.year
                                    ] = year_value;
                                }

                                window.codepoet.guides_select.products[el.id] =
                                    {
                                        title: el.title,
                                        filter:
                                            "cat-" +
                                            el.category.term_id +
                                            " year-" +
                                            el.year,
                                    };
                            });

                            var options_products =
                                    '<option value="">' +
                                    site_vars.guide_product_select +
                                    "</option>",
                                options_cats =
                                    '<option value="">' +
                                    site_vars.guide_cat_select +
                                    "</option>",
                                options_years =
                                    '<option value="">' +
                                    site_vars.guide_year_select +
                                    "</option>";

                            $.each(
                                window.codepoet.guides_select.cats,
                                function (index, el) {
                                    options_cats +=
                                        '<option value="cat-' +
                                        index +
                                        '">' +
                                        el.title +
                                        "</option>";
                                }
                            );

                            jQuery("#categories_select").html(options_cats);

                            $.each(
                                window.codepoet.guides_select.years,
                                function (index, el) {
                                    options_years +=
                                        '<option value="year-' +
                                        index +
                                        '" data-chained="' +
                                        el.filter +
                                        '">' +
                                        el.title +
                                        "</option>";
                                }
                            );

                            jQuery("#years_select").html(options_years);

                            $.each(
                                window.codepoet.guides_select.products,
                                function (index, el) {
                                    options_products +=
                                        '<option value="' +
                                        index +
                                        '" data-chained="' +
                                        el.filter +
                                        '">' +
                                        el.title +
                                        "</option>";
                                }
                            );

                            jQuery("#products_select").html(options_products);

                            jQuery("#years_select").chainedTo(
                                "#categories_select"
                            );
                            jQuery("#products_select").chainedTo(
                                "#categories_select"
                            );

                            jQuery("#products_select").on(
                                "change",
                                function (event) {
                                    event.preventDefault();
                                    var value = jQuery(this).val();
                                    if (value) {
                                        load_guide(value, true);
                                        jQuery("#autocomplete").val(
                                            jQuery(
                                                "#products_select option:selected"
                                            ).text()
                                        );
                                    } else {
                                        load_guide("reset", true);
                                    }
                                }
                            );

                            var options = {
                                data: window.codepoet.guides_autocomplete,
                                getValue: "title",
                                template: {
                                    type: "custom",
                                    method: function (value, item) {
                                        var img = "",
                                            model = "";
                                        if (item.image) {
                                            img =
                                                '<div class="image_autocomplete"><img src="' +
                                                item.image +
                                                '" /></div>';
                                        }
                                        if (item.model) {
                                            model =
                                                '<div class="model_autocomplete">' +
                                                item.model +
                                                "</div>";
                                        }
                                        return (
                                            img +
                                            '<div class="title_autocomplete">' +
                                            value +
                                            "</div>" +
                                            model
                                        );
                                    },
                                },
                                list: {
                                    onChooseEvent: function (data) {
                                        window.codepoet.guide_selected =
                                            jQuery(
                                                "#autocomplete"
                                            ).getSelectedItemData();
                                        load_guide(
                                            window.codepoet.guide_selected.id,
                                            true
                                        );
                                    },
                                    match: {
                                        enabled: true,
                                    },
                                },
                            };

                            jQuery("#autocomplete").easyAutocomplete(options);

                            jQuery("#guides_search").removeClass("loading");

                            if (site_vars.current_post_type == "guides") {
                            } else {
                                window.onpopstate = function (event) {
                                    if (event.state === null) {
                                        load_guide("reset", true);
                                    } else if (event.state.id) {
                                        load_guide(event.state.id, true);
                                    }
                                };
                            }

                            jQuery(".guide_wrap").removeClass("loading");
                        })
                        .fail(function () {
                            console.log("error");
                        });
                }
            },
        },
        experience: {
            init: function () {
                window.codepoet.geocoder = new google.maps.Geocoder();

                setTimeout(function () {
                    var wpsl_results =
                        document.querySelector("#wpsl-result-list");

                    jQuery("#wpsl-search-btn").on("click", function (event) {
                        if (jQuery("#wpsl-search-input").val() != "") {
                            jQuery("html, body").animate(
                                {
                                    scrollTop:
                                        jQuery("#wpsl-gmap").offset().top - 100,
                                },
                                750
                            );

                            geocode_request();
                            window.codepoet.geo_code_request = false;

                            jQuery(".no-result-container").hide();

                            wpsl_results.scrollTop = 0;
                        }
                    });
                }, 2000);

                jQuery("#wpsl-search-input").on("keypress", function (e) {
                    if (e.which == 13) {
                        var firstResult = jQuery(
                            ".pac-container .pac-item:first"
                        ).text();
                        window.codepoet.geocoder.geocode(
                            { address: firstResult },
                            function (results, status) {
                                if (status == google.maps.GeocoderStatus.OK) {
                                    var placeName =
                                        results[0].address_components[0]
                                            .long_name;
                                    window.codepoet.geo_code_request =
                                        results[0];
                                    jQuery("#wpsl-search-input").val(placeName);
                                    jQuery("#wpsl-search-btn").trigger("click");
                                }
                            }
                        );
                        return false;
                    }
                });

                jQuery(document).ajaxComplete(function (event, xhr, settings) {
                    var param = getParameterByName("action", settings.url);
                    if (param == "store_search") {
                        if (
                            jQuery("#wpsl-stores").find(".wpsl-no-results-msg")
                                .length > 0
                        ) {
                            var current_country =
                                window.codepoet.current_experience_country;
                            var $country_el = jQuery(
                                "#country-" + current_country
                            );
                            if ($country_el.length > 0) {
                                $country_el.show();
                            } else {
                                jQuery("#country-default").show();
                            }
                        }
                    }
                });
            },
        },
        legacy: {
            init: function () {
                tabs_buttons();

                jQuery(".bxslider").each(function (index, el) {
                    window.codepoet.sliders[index + 1] = jQuery(el).bxSlider({
                        mode: "fade",
                        controls: false,
                        pager: false,
                        auto: false,
                        touchEnabled: false,
                    });
                });

                jQuery(".history_slider_controls .next").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                        var slider_id = jQuery(this).data("slider");
                        window.codepoet.sliders[slider_id].goToNextSlide();
                    }
                );

                jQuery(".history_slider_controls .prev").on(
                    "click",
                    function (event) {
                        event.preventDefault();
                        var slider_id = jQuery(this).data("slider");
                        window.codepoet.sliders[slider_id].goToPrevSlide();
                    }
                );

                jQuery(".year_link").on("click", function (event) {
                    event.preventDefault();
                    var offset_id = jQuery(this).data("year");
                    jQuery("html, body").animate(
                        {
                            scrollTop:
                                jQuery("#" + offset_id).offset().top - 100,
                        },
                        750
                    );
                    jQuery(".year_link").removeClass("active");
                    jQuery(this).addClass("active");
                });
            },
        },
        page_template_template_home_v2: {
            init: function () {
                window.codepoet.v2slider = jQuery(".slider-top");

                if (window.codepoet.v2slider.length) {
                    const start_video = function ($el, init = false) {
                        let $video = $el.find("video");
                        if ($video.length) {
                            if (init) {
                                setTimeout(function () {
                                    window.codepoet.v2slider.slick(
                                        "slickPause"
                                    );
                                }, 1);
                            } else {
                                window.codepoet.v2slider.slick("slickPause");
                            }

                            $video
                                .on("ended", function (event) {
                                    window.codepoet.v2slider.slick("slickNext");
                                })
                                .get(0)
                                .play();
                        }
                    };
                    const stop_video = function ($el) {
                        $video = $el.find("video");
                        if ($video.length) {
                            $video.get(0).pause();
                            $video.get(0).currentTime = 0;
                            window.codepoet.v2slider.slick("slickPlay");
                            $video.off("ended");
                        }
                    };
                    const start_progressbar = function (
                        $slider,
                        timer,
                        progressIndex,
                        reset
                    ) {
                        let timeout = 0;

                        if (isNaN(timer)) {
                            timer = 10000;
                        }

                        jQuery(".progress_slide").removeClass("active");

                        jQuery(".progress_slide")
                            .eq(progressIndex)
                            .find(".slide_width svg .circle")
                            .css("animationDuration", timer + "ms")
                            .parent()
                            .addClass("active");
                    };

                    let slick_settings = {
                        infinite: true,
                        autoplay: true,
                        autoplaySpeed: 10000,
                        arrows: false,
                        pauseOnHover: false,
                        dots: true,
                        fade: true,
                        rows: 0,
                        customPaging: function (slick, index) {
                            return (
                                '<a><div class="progress_slide"><div class="slide_width"></div></div><span class="label_wrap">' +
                                jQuery(slick.$slides[index]).data("label") +
                                "</label></a>"
                            );
                        },
                    };

                    window.codepoet.v2slider.on(
                        "init",
                        function (event, slick) {
                            jQuery(".covervid_slider").each(function (
                                index,
                                el
                            ) {
                                var $video = jQuery(this).find("video");
                                $video.coverVid(
                                    $video.data("width"),
                                    $video.data("height")
                                );
                            });

                            let $currentSlide = window.codepoet.v2slider.find(
                                '.slide[data-slick-index="' +
                                    slick.currentSlide +
                                    '"]'
                            );
                            let timer = slick_settings.autoplaySpeed,
                                reset = false;

                            if ($currentSlide.hasClass("video")) {
                                let $currentVideo = $currentSlide.find("video"),
                                    time = "";
                                if ($currentVideo.length) {
                                    if (isNaN($currentVideo.get(0).duration)) {
                                        $currentVideo.on(
                                            "loadedmetadata",
                                            function () {
                                                time =
                                                    $currentVideo.get(
                                                        0
                                                    ).duration;

                                                start_video(
                                                    $currentSlide,
                                                    true
                                                );
                                                if (!isNaN(time)) {
                                                    timer = time * 1000;
                                                }
                                                start_progressbar(
                                                    window.codepoet.v2slider,
                                                    timer,
                                                    slick.currentSlide,
                                                    reset
                                                );
                                            }
                                        );
                                    } else {
                                        time =
                                            $currentVideo.get(0).duration *
                                            1000;

                                        start_video($currentSlide, true);
                                        start_progressbar(
                                            window.codepoet.v2slider,
                                            timer,
                                            slick.currentSlide,
                                            reset
                                        );
                                    }
                                }
                            } else {
                                setTimeout(function () {
                                    window.codepoet.v2slider.slick("slickPlay");
                                }, 1);

                                start_progressbar(
                                    window.codepoet.v2slider,
                                    timer,
                                    slick.currentSlide,
                                    reset
                                );
                            }
                        }
                    );

                    window.codepoet.v2slider.on(
                        "afterChange",
                        function (event, slick, currentSlide) {
                            let $currentSlide = window.codepoet.v2slider.find(
                                '.slide[data-slick-index="' +
                                    currentSlide +
                                    '"]'
                            );
                            let timer = slick_settings.autoplaySpeed,
                                reset = false;
                            if ($currentSlide.hasClass("video")) {
                                start_video(
                                    $currentSlide,
                                    window.codepoet.v2slider
                                );
                                let $currentVideo = $currentSlide.find("video"),
                                    time = "";
                                if ($currentVideo.length) {
                                    time = $currentVideo.get(0).duration;
                                }
                                if (!isNaN(time)) {
                                    timer = time * 1000;
                                }
                            }

                            if (currentSlide == 0) {
                                reset = true;
                            }

                            start_progressbar(
                                window.codepoet.v2slider,
                                timer,
                                currentSlide,
                                reset
                            );
                        }
                    );

                    window.codepoet.v2slider.on(
                        "beforeChange",
                        function (event, slick, currentSlide, nextSlide) {
                            let $currentSlide = window.codepoet.v2slider.find(
                                '.slide[data-slick-index="' +
                                    currentSlide +
                                    '"]'
                            );
                            if ($currentSlide.hasClass("video")) {
                                stop_video($currentSlide);
                            }
                        }
                    );

                    window.codepoet.v2slider.slick(slick_settings);
                }

                let $product_slider = jQuery(".product_slider");

                if ($product_slider.length) {
                    let product_slider_slick_settings = {
                        infinite: false,
                        autoplay: false,
                        arrows: true,
                        nextArrow:
                            '<button type="button" class="slick-next"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAABB0lEQVRIS63W0Q3CMAwE0OsEMAJMACPAJjAZ7STABMAmsAE6FKPgJrYTkb+i6jU+py4DftcSwArAXf3uXg7ZHUTOCdq3YgIJsk3wE0ATRkgjsskmjJBksigEEcakNJZ0AVDD1gCIVlcetoWxi8ysiuUQn9aNaagbK0HEdulMlTIpllmDCBwAnCrpzjAL8jB2mQ34LA/ysBHAMQqFsMiOZPdWZuO/oCkKWbuZ2OEI5CKRsC3kmg6u234LeSTk+xL3vCIzpFYaJwBnNyenXkWkBHUhGupGcshCXmmuu6OWw/9WyYQIZ5P7wZTPEUfCRiUbRvLS2KEca0J02IKx1FA5eQX6QHb/iXgDHDFLXiOkIIEAAAAASUVORK5CYII=" /></button>',
                        prevArrow:
                            '<button type="button" class="slick-prev"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAABB0lEQVRIS63W0Q3CMAwE0OsEMAJMACPAJjAZ7STABMAmsAE6FKPgJrYTkb+i6jU+py4DftcSwArAXf3uXg7ZHUTOCdq3YgIJsk3wE0ATRkgjsskmjJBksigEEcakNJZ0AVDD1gCIVlcetoWxi8ysiuUQn9aNaagbK0HEdulMlTIpllmDCBwAnCrpzjAL8jB2mQ34LA/ysBHAMQqFsMiOZPdWZuO/oCkKWbuZ2OEI5CKRsC3kmg6u234LeSTk+xL3vCIzpFYaJwBnNyenXkWkBHUhGupGcshCXmmuu6OWw/9WyYQIZ5P7wZTPEUfCRiUbRvLS2KEca0J02IKx1FA5eQX6QHb/iXgDHDFLXiOkIIEAAAAASUVORK5CYII=" /></button>',
                        dots: false,
                        rows: 0,
                        draggable: true,
                        slidesToShow: 3.1,
                        slidesToScroll: 3,
                        responsive: [
                            {
                                breakpoint: 1399,
                                settings: {
                                    slidesToShow: 2.1,
                                    slidesToScroll: 2,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    arrows: false,
                                    slidesToShow: 1.1,
                                    slidesToScroll: 1,
                                },
                            },
                        ],
                    };
                    $product_slider.slick(product_slider_slick_settings);
                }
                news_v2_carousel();
            },
        },
        page_template_template_home_v3: {
            init: function () {
                window.codepoet.v3slider = jQuery(".slider-top.v3");

                if (window.codepoet.v3slider.length) {
                    const start_video = function ($el, init = false) {
                        let $video = $el.find("video");
                        if ($video.length) {
                            if (init) {
                                setTimeout(function () {
                                    window.codepoet.v3slider.slick(
                                        "slickPause"
                                    );
                                }, 1);
                            } else {
                                window.codepoet.v3slider.slick("slickPause");
                            }

                            $video
                                .on("ended", function (event) {
                                    window.codepoet.v3slider.slick("slickNext");
                                })
                                .get(0)
                                .play();
                        }
                    };
                    const stop_video = function ($el) {
                        $video = $el.find("video");
                        if ($video.length) {
                            $video.get(0).pause();
                            $video.get(0).currentTime = 0;
                            window.codepoet.v3slider.slick("slickPlay");
                            $video.off("ended");
                        }
                    };
                    const start_progressbar = function (
                        $slider,
                        timer,
                        progressIndex,
                        reset
                    ) {
                        let timeout = 0;

                        if (isNaN(timer)) {
                            timer = 10000;
                        }

                        jQuery(".progress_slide").removeClass("active");

                        jQuery(".progress_slide")
                            .eq(progressIndex)
                            .find(".slide_width svg .circle")
                            .css("animationDuration", timer + "ms")
                            .parent()
                            .addClass("active");
                    };

                    let slick_settings = {
                        infinite: true,
                        autoplay: true,
                        autoplaySpeed: 10000,
                        arrows: false,
                        pauseOnHover: false,
                        dots: true,
                        fade: true,
                        rows: 0,
                        customPaging: function (slick, index) {
                            return '<a><div class="progress_slide"><div class="slide_width"><svg viewBox="0 0 30 30"><circle class="circle" pathLength="100" cx="15" cy="15" r="13" stroke="#000" stroke-width="1" fill-opacity="0" /></svg></div></div><span class="label_wrap"></a>';
                        },
                    };

                    window.codepoet.v3slider.on(
                        "init",
                        function (event, slick) {
                            jQuery(".covervid_slider").each(function (
                                index,
                                el
                            ) {
                                var $video = jQuery(this).find("video");
                                $video.coverVid(
                                    $video.data("width"),
                                    $video.data("height")
                                );
                            });

                            let $currentSlide = window.codepoet.v3slider.find(
                                '.slide[data-slick-index="' +
                                    slick.currentSlide +
                                    '"]'
                            );
                            let timer = slick_settings.autoplaySpeed,
                                reset = false;

                            if ($currentSlide.hasClass("video")) {
                                let $currentVideo = $currentSlide.find("video"),
                                    time = "";
                                if ($currentVideo.length) {
                                    if (isNaN($currentVideo.get(0).duration)) {
                                        $currentVideo.on(
                                            "loadedmetadata",
                                            function () {
                                                time =
                                                    $currentVideo.get(
                                                        0
                                                    ).duration;

                                                start_video(
                                                    $currentSlide,
                                                    true
                                                );
                                                if (!isNaN(time)) {
                                                    timer = time * 1000;
                                                }
                                                start_progressbar(
                                                    window.codepoet.v3slider,
                                                    timer,
                                                    slick.currentSlide,
                                                    reset
                                                );
                                            }
                                        );
                                    } else {
                                        time =
                                            $currentVideo.get(0).duration *
                                            1000;

                                        start_video($currentSlide, true);
                                        start_progressbar(
                                            window.codepoet.v3slider,
                                            timer,
                                            slick.currentSlide,
                                            reset
                                        );
                                    }
                                }
                            } else {
                                setTimeout(function () {
                                    window.codepoet.v3slider.slick("slickPlay");
                                }, 1);

                                start_progressbar(
                                    window.codepoet.v3slider,
                                    timer,
                                    slick.currentSlide,
                                    reset
                                );
                            }
                        }
                    );

                    window.codepoet.v3slider.on(
                        "afterChange",
                        function (event, slick, currentSlide) {
                            let $currentSlide = window.codepoet.v3slider.find(
                                '.slide[data-slick-index="' +
                                    currentSlide +
                                    '"]'
                            );
                            let timer = slick_settings.autoplaySpeed,
                                reset = false;
                            if ($currentSlide.hasClass("video")) {
                                start_video(
                                    $currentSlide,
                                    window.codepoet.v3slider
                                );
                                let $currentVideo = $currentSlide.find("video"),
                                    time = "";
                                if ($currentVideo.length) {
                                    time = $currentVideo.get(0).duration;
                                }
                                if (!isNaN(time)) {
                                    timer = time * 1000;
                                }
                            }

                            if (currentSlide == 0) {
                                reset = true;
                            }

                            start_progressbar(
                                window.codepoet.v3slider,
                                timer,
                                currentSlide,
                                reset
                            );
                        }
                    );

                    window.codepoet.v3slider.on(
                        "beforeChange",
                        function (event, slick, currentSlide, nextSlide) {
                            let $currentSlide = window.codepoet.v3slider.find(
                                '.slide[data-slick-index="' +
                                    currentSlide +
                                    '"]'
                            );
                            if ($currentSlide.hasClass("video")) {
                                stop_video($currentSlide);
                            }
                        }
                    );

                    window.codepoet.v3slider.slick(slick_settings);
                }

                let $product_slider = jQuery(".product_slider");

                if ($product_slider.length) {
                    let product_slider_slick_settings = {
                        infinite: false,
                        autoplay: false,
                        arrows: true,
                        nextArrow:
                            '<button type="button" class="slick-next"><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMjI0MTggMTQuMzMzOUMxMC44MjI5IDExLjc4MjUgMTMuMTc4OSA5LjQgMTUuNDc0NiA3LjE2N0MxMi44NzQ4IDQuNjE5OTIgMTAuNTE3NiAyLjIyOTk1IDguMjI0MTkgNC42MDk2MmUtMDVDNy42MjY5NCAwLjU4MDgyMSA3LjE3NjggMS4wMjc2NSA2LjYwNTkyIDEuNTgzMThDOC4xNTcyMSAzLjExOTEgOS43NjAyMiA0LjcwODgyIDExLjEwNjIgNi4wNDE1OUwxLjQyNTE5IDYuMDQxNTlDMS4xMjg3NiA2LjA0MTU5IDAuODU5NzkzIDYuMzA5NDcgMC44NTk3OTMgNi42MDQ4TDAuODU5NzkzIDcuNzMwMTJDMC44NTk3OTMgOC4wMjQzNiAxLjEyOTg3IDguMjkzMzMgMS40MjUxOSA4LjI5MzMzTDExLjEwNjIgOC4yOTMzM0M5LjYwMSA5Ljc3MjE3IDguMTE3NzIgMTEuMjcyIDYuNjA1OTIgMTIuNzQzQzcuMTQ5MzcgMTMuMjg1NCA3Ljc0NjYxIDEzLjg2MDcgOC4yMjQxOCAxNC4zMzVMOC4yMjQxOCAxNC4zMzM5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==" /></button>',
                        prevArrow:
                            '<button type="button" class="slick-prev"><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMjI0MTggMTQuMzMzOUMxMC44MjI5IDExLjc4MjUgMTMuMTc4OSA5LjQgMTUuNDc0NiA3LjE2N0MxMi44NzQ4IDQuNjE5OTIgMTAuNTE3NiAyLjIyOTk1IDguMjI0MTkgNC42MDk2MmUtMDVDNy42MjY5NCAwLjU4MDgyMSA3LjE3NjggMS4wMjc2NSA2LjYwNTkyIDEuNTgzMThDOC4xNTcyMSAzLjExOTEgOS43NjAyMiA0LjcwODgyIDExLjEwNjIgNi4wNDE1OUwxLjQyNTE5IDYuMDQxNTlDMS4xMjg3NiA2LjA0MTU5IDAuODU5NzkzIDYuMzA5NDcgMC44NTk3OTMgNi42MDQ4TDAuODU5NzkzIDcuNzMwMTJDMC44NTk3OTMgOC4wMjQzNiAxLjEyOTg3IDguMjkzMzMgMS40MjUxOSA4LjI5MzMzTDExLjEwNjIgOC4yOTMzM0M5LjYwMSA5Ljc3MjE3IDguMTE3NzIgMTEuMjcyIDYuNjA1OTIgMTIuNzQzQzcuMTQ5MzcgMTMuMjg1NCA3Ljc0NjYxIDEzLjg2MDcgOC4yMjQxOCAxNC4zMzVMOC4yMjQxOCAxNC4zMzM5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==" /></button>',
                        dots: false,
                        rows: 0,
                        draggable: true,
                        slidesToShow: 3.25,
                        slidesToScroll: 3,
                        responsive: [
                            {
                                breakpoint: 1399,
                                settings: {
                                    arrows: true,
                                    slidesToShow: 2.25,
                                    slidesToScroll: 2,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    arrows: false,
                                    slidesToShow: 1.25,
                                    slidesToScroll: 1,
                                },
                            },
                        ],
                    };
                    $product_slider.slick(product_slider_slick_settings);
                }

                let $home_reviews_slider = jQuery(".home_reviews_slider");

                if ($home_reviews_slider.length) {
                    let home_reviews_slider_slick_settings = {
                        infinite: false,
                        autoplay: false,
                        arrows: true,
                        nextArrow:
                            '<button type="button" class="slick-next"><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMjI0MTggMTQuMzMzOUMxMC44MjI5IDExLjc4MjUgMTMuMTc4OSA5LjQgMTUuNDc0NiA3LjE2N0MxMi44NzQ4IDQuNjE5OTIgMTAuNTE3NiAyLjIyOTk1IDguMjI0MTkgNC42MDk2MmUtMDVDNy42MjY5NCAwLjU4MDgyMSA3LjE3NjggMS4wMjc2NSA2LjYwNTkyIDEuNTgzMThDOC4xNTcyMSAzLjExOTEgOS43NjAyMiA0LjcwODgyIDExLjEwNjIgNi4wNDE1OUwxLjQyNTE5IDYuMDQxNTlDMS4xMjg3NiA2LjA0MTU5IDAuODU5NzkzIDYuMzA5NDcgMC44NTk3OTMgNi42MDQ4TDAuODU5NzkzIDcuNzMwMTJDMC44NTk3OTMgOC4wMjQzNiAxLjEyOTg3IDguMjkzMzMgMS40MjUxOSA4LjI5MzMzTDExLjEwNjIgOC4yOTMzM0M5LjYwMSA5Ljc3MjE3IDguMTE3NzIgMTEuMjcyIDYuNjA1OTIgMTIuNzQzQzcuMTQ5MzcgMTMuMjg1NCA3Ljc0NjYxIDEzLjg2MDcgOC4yMjQxOCAxNC4zMzVMOC4yMjQxOCAxNC4zMzM5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==" /></button>',
                        prevArrow:
                            '<button type="button" class="slick-prev"><img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMjI0MTggMTQuMzMzOUMxMC44MjI5IDExLjc4MjUgMTMuMTc4OSA5LjQgMTUuNDc0NiA3LjE2N0MxMi44NzQ4IDQuNjE5OTIgMTAuNTE3NiAyLjIyOTk1IDguMjI0MTkgNC42MDk2MmUtMDVDNy42MjY5NCAwLjU4MDgyMSA3LjE3NjggMS4wMjc2NSA2LjYwNTkyIDEuNTgzMThDOC4xNTcyMSAzLjExOTEgOS43NjAyMiA0LjcwODgyIDExLjEwNjIgNi4wNDE1OUwxLjQyNTE5IDYuMDQxNTlDMS4xMjg3NiA2LjA0MTU5IDAuODU5NzkzIDYuMzA5NDcgMC44NTk3OTMgNi42MDQ4TDAuODU5NzkzIDcuNzMwMTJDMC44NTk3OTMgOC4wMjQzNiAxLjEyOTg3IDguMjkzMzMgMS40MjUxOSA4LjI5MzMzTDExLjEwNjIgOC4yOTMzM0M5LjYwMSA5Ljc3MjE3IDguMTE3NzIgMTEuMjcyIDYuNjA1OTIgMTIuNzQzQzcuMTQ5MzcgMTMuMjg1NCA3Ljc0NjYxIDEzLjg2MDcgOC4yMjQxOCAxNC4zMzVMOC4yMjQxOCAxNC4zMzM5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==" /></button>',
                        dots: false,
                        rows: 0,
                        draggable: true,
                        slidesToShow: 4,
                        slidesToScroll: 2,
                        responsive: [
                            {
                                breakpoint: 1399,
                                settings: {
                                    arrows: true,
                                    dots: false,
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                },
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    arrows: false,
                                    dots: true,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                },
                            },
                        ],
                    };
                    $home_reviews_slider.slick(
                        home_reviews_slider_slick_settings
                    );
                }
                news_v2_carousel();
            },
        },
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var namespace = codepoet;
            funcname = funcname === undefined ? "init" : funcname;
            if (
                func !== "" &&
                namespace[func] &&
                typeof namespace[func][funcname] === "function"
            ) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            UTIL.fire("common");

            jQuery.each(
                document.body.className.replace(/-/g, "_").split(/\s+/),
                function (i, classnm) {
                    UTIL.fire(classnm);
                }
            );
        },
    };

    jQuery(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

function login_buttons() {
    jQuery(".login_button").on("click", function (event) {
        event.preventDefault();
        var new_tab = jQuery(this).data("tab"),
            other_tab = jQuery(this).data("switch");
        jQuery(".login_button, .login_text").removeClass("active");
        jQuery("." + other_tab).addClass("active");
        jQuery(".login_text." + new_tab).addClass("active");
        jQuery(".form_hide").hide();
        jQuery("." + new_tab).fadeIn(250);
    });
}

function tabs_buttons() {
    jQuery(".tab_link").on("click", function (event) {
        event.preventDefault();
        if (!jQuery(this).hasClass("active")) {
            var new_tab = jQuery(this).data("tab"),
                tabs_wrap = jQuery(this).data("wrap");

            jQuery("." + tabs_wrap)
                .find(".tab_link")
                .removeClass("active");
            jQuery("." + tabs_wrap)
                .find(".tab_content")
                .removeClass("active")
                .hide();
            jQuery(this).addClass("active");
            jQuery("#" + new_tab)
                .addClass("active")
                .fadeIn(250);
        }
    });
}

function get_product_cat_title(ID) {
    var title = "";
    jQuery
        .ajax({
            url: site_vars.root + "codepoet/v1/product_cat/" + ID,
            data: { lang: site_vars.current_language },
        })
        .done(function (data) {
            console.log(data);
        })
        .fail(function () {
            console.log("error");
        });
    return title;
}

function load_guide(ID, add_history) {
    jQuery("#guide").html(window.codepoet.guides_html);

    if (ID == "reset") {
        jQuery("#guide").addClass("hide");
        jQuery("#autocomplete").val("");
        if (history.pushState) {
            window.history.pushState(
                { id: "reset" },
                document.title,
                window.codepoet.current_url
            );
        }
    } else {
        var data = searchGuideByID(parseInt(ID), window.codepoet.single_guides);

        if (!data) {
            jQuery
                .ajax({
                    url: site_vars.root + "codepoet/v1/guides/" + ID,
                    data: {
                        lang: site_vars.current_language,
                    },
                    beforeSend: function () {
                        jQuery(".guide_wrap").addClass("loading");
                    },
                })
                .done(function (remoteData) {
                    data = remoteData;
                    var cleaned_link = data.link;
                    window.codepoet.single_guides.push(data);
                    jQuery(".guide_wrap").removeClass("loading");
                    jQuery(".loading_single_guide").hide();
                    load_guide_html(data, add_history, ID, cleaned_link);
                });
        } else {
            var cleaned_link = data.link;
            load_guide_html(data, add_history, ID, cleaned_link);
        }
    }
}

function load_guide_html(data, add_history, ID, cleaned_link) {
    directive = {
        ".product .title": "title.rendered",
        ".product .cat": "acf.category.name",
        ".product .year": function () {
            if (this.acf.year) {
                return (
                    "<span>" +
                    site_vars.launched_year +
                    "</span>" +
                    this.acf.year
                );
            }
        },
        ".product .discontinued_year": function () {
            if (this.acf.year_discontinued) {
                return (
                    "<span>" +
                    site_vars.discontinued +
                    "</span>" +
                    this.acf.year_discontinued
                );
            }
        },
        ".product .product_url": function () {
            if (this.acf.related_product) {
                var link_text = site_vars.view_product_current;
                if (this.acf.year_discontinued) {
                    link_text = site_vars.view_product_discontinued;
                }
                return (
                    '<a href="' +
                    window.codepoet.current_host +
                    "/?p=" +
                    this.acf.related_product +
                    '">' +
                    link_text +
                    "</a>"
                );
            }
        },
        ".product .image": function () {
            if (this.acf.image) {
                return '<img src="' + this.acf.image.url + '" />';
            }
        },
        ".product .description": "acf.description",
    };

    jQuery("#guide").render(data, directive);

    var items_data = {
        ".element": {
            "data<-": {
                "a.link@href": "data.file.url",
                "a.link .title": "data.title",
                "a.link .data_right .icon": function (a) {
                    if (a.item.file.url) {
                        return '<img src="' + a.item.file.icon + '" />';
                    }
                },
                "a.link .data_right .type": "data.file.mime_type",
                "a.link .data_right .size": "data.file.file_size",
            },
        },
    };

    if (data.acf.manuals) {
        jQuery("#guide .user_manuals").removeClass("hidden");
        $p("#guide .user_manuals .data").render(data.acf.manuals, items_data);
    }

    if (data.acf.quickstart) {
        jQuery("#guide .quickstart").removeClass("hidden");
        $p("#guide .quickstart .data").render(data.acf.quickstart, items_data);
    }

    if (data.acf.drivers) {
        jQuery("#guide .drivers").removeClass("hidden");
        $p("#guide .drivers .data").render(data.acf.drivers, items_data);
    }

    if (data.acf.brochures) {
        jQuery("#guide .brochures").removeClass("hidden");
        $p("#guide .brochures .data").render(data.acf.brochures, items_data);
    }

    if (data.acf.upgrades) {
        jQuery("#guide .upgrades").removeClass("hidden");
        $p("#guide .upgrades .data").render(data.acf.upgrades, items_data);
    }

    if (data.acf.videos) {
        var videos_data = {
            ".element": {
                "data<-": {
                    ".video": function (a) {
                        return a.item.the_video;
                    },
                },
            },
        };
        jQuery("#guide .videos").removeClass("hidden");
        $p("#guide .videos .data").render(data.acf.videos, videos_data);
        jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(
            function () {
                if (
                    jQuery(this).innerWidth() / jQuery(this).innerHeight() >
                    1.5
                ) {
                    jQuery(this).wrap("<div class='widescreen flex-video'/>");
                } else {
                    jQuery(this).wrap("<div class='flex-video'/>");
                }
            }
        );
    }

    jQuery("#guide").removeClass("hide");

    jQuery("html, body").animate(
        {
            scrollTop: jQuery("#guide").offset().top - 100,
        },
        500
    );

    if (site_vars.current_post_type != "guides") {
        gtag("config", "UA-50951519-1", {
            page_title: data.title + " | MOON - Simaudio",
            page_location: cleaned_link,
        });
    }

    if (add_history) {
        if (history.pushState) {
            window.history.pushState(
                { id: ID },
                data.title + " | MOON - Simaudio",
                cleaned_link
            );
        }
    }

    jQuery(".user_manuals .content_list a").on("click", function (event) {
        var product_title = data.title,
            pdf_title = jQuery(this).find(".title").text();
        gtag("event", "Download", {
            event_category: "Guides",
            event_label: pdf_title + " for product : " + product_title,
        });
    });
}

function searchGuideByID(ID, array) {
    for (var i = 0; i < array.length; i++) {
        if (array[i].id === ID) {
            return array[i];
        }
    }
    return false;
}

function awards_section() {
    if (jQuery("#awards-etc").length) {
        if (jQuery(window).width() > 1023) {
            var remove = jQuery("#pull_left_content").width() * 0.1466667,
                position_awards =
                    jQuery("#image_pull_left").position().top - remove;

            var content_left_height_title = jQuery(
                    "#content_height_left .title_wrap"
                ).outerHeight(),
                content_left_height_text = jQuery(
                    "#content_height_left .content_wrap"
                ).outerHeight(),
                total_height =
                    content_left_height_text + content_left_height_title + 40;

            if (total_height < position_awards) {
                jQuery("#awards-etc")
                    .addClass("active")
                    .css("top", position_awards);
            } else {
                jQuery("#awards-etc").removeClass("active");
            }
        } else {
            jQuery("#awards-etc").removeClass("active");
        }
    }
}

function run_animations() {
    jQuery(window).on("site_loaded", function (event) {
        var content = appear({
            elements: function elements() {
                return [document.getElementById("content")];
            },
            appear: function appear(el) {
                el.className += " down_push";
            },
        });

        if (document.getElementById("home_slider") !== null) {
            var home_slider = appear({
                elements: function elements() {
                    return document
                        .getElementById("home_slider")
                        .querySelectorAll(".content");
                },
                appear: function appear(el) {
                    el.className += " fadeTopBackOn";
                },
            });
        }

        if (document.getElementById("pull_left_content") !== null) {
            var pull_left_content = appear({
                elements: function elements() {
                    return [document.getElementById("pull_left_content")];
                },
                appear: function appear(el) {
                    awards_section();
                },
            });
        }

        if (document.getElementById("section6") !== null) {
            var section6_slider = appear({
                elements: function elements() {
                    return [document.getElementById("section6")];
                },
                appear: function appear(el) {
                    if (window.codepoet.video_carousel) {
                        window.codepoet.video_carousel.resize();
                    }
                },
            });
        }

        var pull_down = appear({
            elements: function elements() {
                return document.getElementsByClassName("pull_down");
            },
            appear: function appear(el) {
                el.className += " active";
            },
        });

        var pull_right = appear({
            elements: function elements() {
                return document.getElementsByClassName("pull_right");
            },
            appear: function appear(el) {
                el.className += " active";
            },
        });

        var pull_down_image = appear({
            elements: function elements() {
                return document.getElementsByClassName("pull_down_image");
            },
            appear: function appear(el) {
                el.className += " active";
                if (jQuery(el).hasClass("trigger_item")) {
                    var $trigger_item = jQuery(el).data("trigger-item");
                    jQuery($trigger_item).addClass("trigger_now");
                }
            },
            bounds: -100,
        });

        window.codepoet.fadeInUp = appear({
            elements: function elements() {
                return document.getElementsByClassName("fade_up_start");
            },
            appear: function appear(el) {
                el.className += " fadeInUp animated";
            },
        });

        var fadeInRight = appear({
            elements: function elements() {
                return document.getElementsByClassName("fr_start_small");
            },
            appear: function appear(el) {
                el.className += " fadeInRightSmall animated";
            },
        });

        var fadeInLeft = appear({
            elements: function elements() {
                return document.getElementsByClassName("fl_start_small");
            },
            appear: function appear(el) {
                el.className += " fadeInLeftSmall animated";
            },
        });

        var fadeIn = appear({
            elements: function elements() {
                return document.getElementsByClassName("start_fadein");
            },
            appear: function appear(el) {
                el.className += " fadeIn animated";
            },
        });

        var fadeInAlternate = appear({
            elements: function elements() {
                return document.getElementsByClassName(
                    "start_fadein_alternate"
                );
            },
            appear: function appear(el) {
                el.className += " fadeIn animated";
                setTimeout(function () {
                    jQuery(".start_fadein_alternate").removeClass(
                        "start_fadein_alternate medium_large_delay fadeIn animated"
                    );
                }, 1000);
            },
        });

        var imageVideoAnimateStart = appear({
            elements: function elements() {
                return document.getElementsByClassName(
                    "imageVideoAnimateStart"
                );
            },
            appear: function appear(el) {
                el.className += " imageVideoAnimate";
            },
        });

        var animate_history = appear({
            elements: function elements() {
                return document.getElementsByClassName("animate_history");
            },
            appear: function appear(el) {
                el.className += " active";
            },
        });

        var legacy_section = appear({
            elements: function elements() {
                return document.getElementsByClassName("legacy_section");
            },
            appear: function appear(el) {
                var slider = jQuery(el).find(".bxslider");
                if (slider.length && window.codepoet.sliders.length != 0) {
                    window.codepoet.sliders[slider.data("id")].resize();
                }
            },
        });
    });
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function set_current_experience_country(place) {
    if (place.address_components.length > 0) {
        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];

            if (addressType == "country") {
                window.codepoet.current_experience_country =
                    place.address_components[i].short_name;
            } else {
                window.codepoet.current_experience_country = "default";
            }
        }
    }
}

function get_geocode_address_part(place, part) {
    if (place.address_components.length > 0) {
        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];

            if (addressType == part) {
                return place.address_components[i].long_name;
            }
        }
    }
}

function close_news_popup() {
    var cookies_news_id = jQuery("#newsletter_cookie_id").val();
    jQuery("#newsletter_pop").fadeOut(250);
    Cookies.set(cookies_news_id, "ok", { expires: 365 });
}

function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

function geocode_request() {
    if (window.codepoet.geo_code_request) {
        set_current_experience_country(window.codepoet.geo_code_request);

        gtag("event", "Search", {
            event_category: "Store Search",
            event_label: get_geocode_address_part(
                window.codepoet.geo_code_request,
                "locality"
            ),
        });
    } else {
        var request = {
            address: jQuery("#wpsl-search-input").val(),
        };

        window.codepoet.geocoder.geocode(request, function (response, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                window.codepoet.current_geocode = response[0];
                set_current_experience_country(window.codepoet.current_geocode);

                gtag("event", "Search", {
                    event_category: "Store Search",
                    event_label: get_geocode_address_part(
                        window.codepoet.current_geocode,
                        "locality"
                    ),
                });
            }
        });
    }
}

function slider_home_loaded() {
    if (window.codepoet.home_slider) {
        var currentIndex = window.codepoet.home_slider.getCurrentSlide();
        if (jQuery("#home_slider .slide").eq(currentIndex).hasClass("video")) {
            window.codepoet.home_slider.stopAuto();
            if (window.codepoet.home_slider.getSlideCount() > 1) {
                var $slider_first_slide = jQuery("#home_slider .slide").eq(
                    currentIndex
                );
                $slider_first_slide.find("video").on("ended", function (event) {
                    $slider_first_slide
                        .find("video")
                        .removeClass("active")
                        .get(0)
                        .pause();
                    $slider_first_slide.find("video").off("ended");
                    window.codepoet.home_slider.goToNextSlide();
                });
            }
            jQuery("#home_slider .slide")
                .eq(currentIndex)
                .find("video")
                .addClass("active")
                .get(0)
                .play();
        } else {
            window.codepoet.home_slider.startAuto();
            window.codepoet.home_slider_auto_started = true;
        }
    }
}

function posts_carousel() {
    if (jQuery(".latest_post_wrap").not(".slick-initialized").length) {
        window.codepoet.post_carousel = jQuery(".latest_post_wrap")
            .not(".slick-initialized")
            .slick({
                infinite: false,
                autoplay: false,
                arrows: false,
                nextArrow:
                    '<button type="button" class="slick-next"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAABB0lEQVRIS63W0Q3CMAwE0OsEMAJMACPAJjAZ7STABMAmsAE6FKPgJrYTkb+i6jU+py4DftcSwArAXf3uXg7ZHUTOCdq3YgIJsk3wE0ATRkgjsskmjJBksigEEcakNJZ0AVDD1gCIVlcetoWxi8ysiuUQn9aNaagbK0HEdulMlTIpllmDCBwAnCrpzjAL8jB2mQ34LA/ysBHAMQqFsMiOZPdWZuO/oCkKWbuZ2OEI5CKRsC3kmg6u234LeSTk+xL3vCIzpFYaJwBnNyenXkWkBHUhGupGcshCXmmuu6OWw/9WyYQIZ5P7wZTPEUfCRiUbRvLS2KEca0J02IKx1FA5eQX6QHb/iXgDHDFLXiOkIIEAAAAASUVORK5CYII=" /></button>',
                prevArrow:
                    '<button type="button" class="slick-prev"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAeCAYAAAAhDE4sAAABB0lEQVRIS63W0Q3CMAwE0OsEMAJMACPAJjAZ7STABMAmsAE6FKPgJrYTkb+i6jU+py4DftcSwArAXf3uXg7ZHUTOCdq3YgIJsk3wE0ATRkgjsskmjJBksigEEcakNJZ0AVDD1gCIVlcetoWxi8ysiuUQn9aNaagbK0HEdulMlTIpllmDCBwAnCrpzjAL8jB2mQ34LA/ysBHAMQqFsMiOZPdWZuO/oCkKWbuZ2OEI5CKRsC3kmg6u234LeSTk+xL3vCIzpFYaJwBnNyenXkWkBHUhGupGcshCXmmuu6OWw/9WyYQIZ5P7wZTPEUfCRiUbRvLS2KEca0J02IKx1FA5eQX6QHb/iXgDHDFLXiOkIIEAAAAASUVORK5CYII=" /></button>',
                dots: false,
                rows: 0,
                draggable: true,
                slidesToShow: 3.25,
                slidesToScroll: 3,
                responsive: [
                    {
                        breakpoint: 1399,
                        settings: {
                            slidesToShow: 2.25,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            arrows: false,
                            slidesToShow: 1.25,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
    }
}

function news_v2_carousel() {
    window.codepoet.news_carousel = jQuery("#section_news .row").slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        rows: 0,
        responsive: [
            {
                breakpoint: 640,
                settings: "unslick",
            },
        ],
    });
}

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function () {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}

function wheelDistance(evt) {
    if (!evt) {
        evt = window.event;
    }

    let w = evt.wheelDelta,
        d = evt.detail;

    if (d) {
        if (w) {
            return (w / d / 40) * d > 0 ? 1 : -1; // Opera
        }
        return -d / 3; // Firefox;
    }

    return w / 120; // IE, Safari & Chrome
}

function get_elevate_themes() {
    var ID = jQuery("#elevate_themes").data("id");
    jQuery
        .ajax({
            url: site_vars.root + "codepoet/v1/elevate_themes/" + ID,
            type: "GET",
            dataType: "json",
        })
        .done(function (data) {
            jQuery("#elevate_themes").html(data);
            var pullDownImageAjax = appear({
                elements: function elements() {
                    return document.getElementsByClassName("pull_down_image");
                },
                appear: function appear(el) {
                    el.className += " active";
                    if (jQuery(el).hasClass("trigger_item")) {
                        var $trigger_item = jQuery(el).data("trigger-item");
                        jQuery($trigger_item).addClass("trigger_now");
                    }
                },
                bounds: -100,
            });

            var fadeInUpAjax = appear({
                elements: function elements() {
                    return document.getElementsByClassName("fade_up_start");
                },
                appear: function appear(el) {
                    el.className += " fadeInUp animated";
                },
            });

            var images_parallax = document.getElementsByClassName("parallax");
            new simpleParallax(images_parallax, { scale: 1.25, breakpoint: 0 });
            jQuery(".entry-content-wrap .content_themes").readmore({
                speed: 75,
                moreLink:
                    '<a href="#" class="read-more-home"><span><i class="fas fa-angle-down"></i> ' +
                    site_vars.read_more +
                    "</span></a>",
                lessLink: false,
                collapsedHeight: 400,
            });
        })
        .fail(function () {
            console.log("error");
        });
}

function video_duration_fix(duration) {
    return parseFloat(String(duration).slice(0, -1));
}

// progress on transfers from the server to the client (downloads)
function updateProgress(oEvent) {
    if (oEvent.lengthComputable) {
        var percentComplete = (oEvent.loaded / oEvent.total) * 100;
        jQuery("#loader_loading_text #loading_percentage").text(
            " " + percentComplete.toFixed(0) + "%"
        );
    } else {
        // Unable to compute progress information since the total size is unknown
    }
}

function transferComplete(evt) {
    site_loading(true);
}

function transferFailed(evt) {
    console.log("An error occurred while transferring the file.");
}

function transferCanceled(evt) {
    console.log("The transfer has been canceled by the user.");
}

function site_loading(force) {
    if (!jQuery("#elevate_header").length) {
        jQuery("#pace_loader_more").fadeOut(100);
        jQuery("body").addClass("pace-done");
    } else {
        jQuery("#loader_loading_text").show();
    }

    if (force) {
        jQuery("#pace_loader_more").fadeOut(100);
        jQuery("body").addClass("pace-done");
    }
}
